(function () {
        // ==========================================
        // CONFIGURACIÓN GLOBAL - DEBE ESTAR PRIMERO
        // ==========================================
        var CONFIG = {
            // 1. URL PARA BUSCAR DATOS
            WEBHOOK_GET_DATA: "https://n8n-shopify-proxy.eduardo-ba5.workers.dev/fetch-order-data",
            WEBHOOK_GET_DATA_FALLBACK: "https://levershealth.app.n8n.cloud/webhook/fetch-order-data",

            // 2. URL PARA ENVIAR EL FORMULARIO FINAL
            WEBHOOK_SUBMIT: "https://n8n-shopify-proxy.eduardo-ba5.workers.dev/medical-intake-form",
            WEBHOOK_SUBMIT_FALLBACK: "https://levershealth.app.n8n.cloud/webhook/medical-intake-form",

            // 2.1 URL PARA REEMBOLSOS (DISAGREE)
            WEBHOOK_REFUND: "https://n8n-shopify-proxy.eduardo-ba5.workers.dev/refund",

            // 3. Dominios permitidos para cumplir con HIPAA
            ALLOWED_DOMAINS: [
                'cdn.shopify.com',
                'n8n-shopify-proxy.eduardo-ba5.workers.dev',
                'workers.dev',
                'levershealth.app.n8n.cloud',
                window.location.hostname
            ],

            // 4. Estados permitidos
            ALLOWED_STATES: ["Arizona", "Colorado", "Florida", "Georgia", "Illinois", "Missouri", "Mississippi",
                "North Carolina", "Nevada", "New York", "North Dakota", "Ohio", "Oklahoma",
                "Oregon", "Pennsylvania", "South Dakota", "Tennessee", "Texas", "Virginia",
                "Washington", "Wyoming", "Michigan", "Connecticut", "Kentucky"]
        };

        // Mapa de variantes GLP con sus thresholds de BMI
        var GLP_VARIANT_THRESHOLDS = {
            // Formato: "Nombre exacto del webhook": "BMI mínimo requerido"

            // Semaglutide
            "Semaglutide (GLP-1) / Microdose": 20,
            "Semaglutide (GLP-1) / Low-Dose": 20,
            "Semaglutide Monthly Subscription (Same Price Any Dose) Submit": 25,
            "Semaglutide Regular Subscription (Up to 1.25mg/wk)": 25,
            "Semaglutide Max Subscription (Up to 2.5mg/wk)": 25,
            "Small: Starter Bottle (5mg)": 25,
            "Large: Maintenance Bottle (10mg)": 25,

            // Tirzepatide
            "Tirzepatide (GLP-1 + GIP) / Microdose": 20,
            "Tirzepatide (GLP-1 + GIP) / Low-Dose": 20,
            "Tirzepatide - Low-Dose Plan (up to 5mg/wk)": 20,
            "Tirzepatide - Starter (20mg)": 25,
            "Tirzepatide - Regular (40mg)": 25,
            "Tirzepatide - Large (80mg)": 25
        };

        // ==========================================
        // REGISTRY DE PRODUCTOS POR ESTADO
        // ==========================================
        // Define qué productos (por ID) están permitidos en qué estados
        // Si un producto no está en este registro, se asume permitido en todos los estados
        var PRODUCT_REGISTRY = {
            // Formato: "product_id": { name: "Nombre del Producto", allowedStates: ["Estado1", "Estado2"] }
            "10108572500273": { 
                 name: "NAD+ Injections", 
                 allowedStates: ["Arizona", "Colorado", "Florida", "Georgia", "Illinois", "Missouri", "Mississippi",
                "North Carolina", "Nevada", "New York", "North Dakota", "Ohio", "Oklahoma", "Maryland",
                "Oregon", "Pennsylvania", "South Dakota", "Tennessee", "Texas", "Virginia",
                "Washington", "Wyoming", "California", "Michigan", "Indiana", "Utah", "South Carolina", "Massachusetts", "Connecticut", "Kentucky", "Wisconsin"]
             },
             "10383127118129": { 
                 name: "GHK-Cu", 
                 allowedStates: ["Arizona", "Colorado", "Florida", "Georgia", "Illinois", "Missouri", "Mississippi",
                "North Carolina", "Nevada", "New York", "North Dakota", "Ohio", "Oklahoma", "Maryland",
                "Oregon", "Pennsylvania", "South Dakota", "Tennessee", "Texas", "Virginia",
                "Washington", "Wyoming", "Michigan", "California", "Indiana", "Utah", "South Carolina", "Massachusetts", "Connecticut", "Kentucky", "Wisconsin"]
             },
             "10422839869745": { 
                 name: "Low and Microdose GLP-1",
                 allowedStates: ["Arizona", "Colorado", "Florida", "Georgia", "Illinois", "Missouri", "Mississippi",
                "North Carolina", "Nevada", "New York", "North Dakota", "Ohio", "Oklahoma", "Maryland",
                "Oregon", "Pennsylvania", "South Dakota", "Tennessee", "Texas", "Virginia",
                "Washington", "Wyoming", "Michigan", "California", "Indiana", "Utah", "South Carolina", "Massachusetts", "Connecticut", "Kentucky", "Wisconsin"]
             },
             "10163978207537": { 
                 name: "Sermorelin",
                 allowedStates: ["Arizona", "Colorado", "Florida", "Georgia", "Illinois", "Missouri", "Mississippi",
                "North Carolina", "Nevada", "New York", "North Dakota", "Ohio", "Oklahoma", "Maryland",
                "Oregon", "Pennsylvania", "South Dakota", "Tennessee", "Texas", "Virginia",
                "Washington", "Wyoming", "Michigan", "California", "Indiana", "Utah", "South Carolina", "Massachusetts", "Connecticut", "Kentucky", "Wisconsin"]
             },
             "10575650029873": { 
                 name: "NAD+ Injections", 
                 allowedStates: ["Arizona", "Colorado", "Florida", "Georgia", "Illinois", "Missouri", "Mississippi",
                "North Carolina", "Nevada", "New York", "North Dakota", "Ohio", "Oklahoma", "Maryland",
                "Oregon", "Pennsylvania", "South Dakota", "Tennessee", "Texas", "Virginia",
                "Washington", "Wyoming", "California", "Michigan", "Indiana", "Utah", "South Carolina", "Massachusetts", "Connecticut", "Kentucky", "Wisconsin"]
             },
             "9414639911217": { 
                 name: "Lipotropic B-12 MIC+",
                 allowedStates: ["Arizona", "Colorado", "Florida", "Georgia", "Illinois", "Missouri", "Mississippi",
                "North Carolina", "Nevada", "New York", "North Dakota", "Ohio", "Oklahoma", "Maryland",
                "Oregon", "Pennsylvania", "South Dakota", "Tennessee", "Texas", "Virginia",
                "Washington", "Wyoming", "Michigan", "California", "Indiana", "Utah", "South Carolina", "Massachusetts", "Connecticut", "Kentucky", "Wisconsin"]
             },
             "8528639394097": { 
                 name: "GLP-1 Products",
                 allowedStates: ["Arizona", "Colorado", "Florida", "Georgia", "Illinois", "Missouri", "Mississippi",
                "North Carolina", "Nevada", "New York", "North Dakota", "Ohio", "Oklahoma", "Maryland",
                "Oregon", "Pennsylvania", "South Dakota", "Tennessee", "Texas", "Virginia",
                "Washington", "Wyoming", "Michigan", "California", "Indiana", "Utah", "South Carolina", "Massachusetts", "Connecticut", "Kentucky", "Wisconsin"]
             },
             "10571743592753": { 
                 name: "Repair & Recovery",
                 allowedStates: ["Arizona", "Colorado", "Florida", "Georgia", "Illinois", "Missouri", "Mississippi",
                "North Carolina", "Nevada", "New York", "North Dakota", "Ohio", "Oklahoma", "Maryland",
                "Oregon", "Pennsylvania", "South Dakota", "Tennessee", "Texas", "Virginia",
                "Washington", "Wyoming", "Michigan", "California", "Indiana", "Utah", "South Carolina", "Massachusetts", "Connecticut", "Kentucky", "Wisconsin"]
             },
             "10621092561201": { 
                 name: "Lean Muscle",
                 allowedStates: ["Arizona", "Colorado", "Florida", "Georgia", "Illinois", "Missouri", "Mississippi",
                "North Carolina", "Nevada", "New York", "North Dakota", "Ohio", "Oklahoma", "Maryland",
                "Oregon", "Pennsylvania", "South Dakota", "Tennessee", "Texas", "Virginia",
                "Washington", "Wyoming", "Michigan", "California", "Indiana", "Utah", "South Carolina", "Massachusetts", "Connecticut", "Kentucky", "Wisconsin"]
             }
        };

        // ==========================================
        // PROTECCIÓN HIPAA: Bloqueo de dominios no autorizados
        // ==========================================
        (function () {
            // Guardar la función fetch original
            var originalFetch = window.fetch;

            window.fetch = function (url, options) {
                try {
                    // Verificar si la URL es válida
                    var urlString = url.toString().trim();
                    var urlObj = new URL(urlString, window.location.href);
                    var hostname = urlObj.hostname;

                    var isAllowed = CONFIG.ALLOWED_DOMAINS.some(function (domain) {
                        domain = domain.trim();
                        return hostname === domain || hostname.endsWith('.' + domain);
                    });

                    // Bloquear envío a dominios no autorizados
                    if (!isAllowed) {
                        /* HIPAA: Bloqueado envío a: [REDACTED] */
                        return Promise.reject(new Error('Dominio no autorizado: ' + hostname));
                    }

                    return originalFetch.apply(this, arguments);
                } catch (e) {
                    // Si hay error parseando la URL, permitir el fetch original
                    return originalFetch.apply(this, arguments);
                }
            };

            // Prevenir clickjacking básico
            if (window.top !== window.self) {
                try {
                    var parentDomain = window.top.location.hostname;
                    if (!parentDomain.endsWith('.myshopify.com') &&
                        !parentDomain.endsWith('.shopify.com') &&
                        !parentDomain.includes('levers.health')) {

                        document.body.innerHTML = '<div style="padding:20px;text-align:center;">' +
                            '<h2>Security Error</h2><p>This form cannot be embedded outside of authorized sites.</p></div>';
                        return; // No usar throw aquí
                    }
                } catch (e) {
                    // Same-origin policy nos impide verificar, asumimos iframe no autorizado
                    document.body.innerHTML = '<div style="padding:20px;text-align:center;">' +
                        '<h2>Security Error</h2><p>This form cannot be embedded.</p></div>';
                }
            }

            // Limpiar datos al salir
            window.addEventListener('beforeunload', function () {
                try {
                    sessionStorage.removeItem('levers_form_draft');
                } catch (e) { }
            });
        })();

        // ==========================================
        // UTILIDADES DE SEGURIDAD
        // ==========================================
        var SecurityUtils = {
            validateMedicalInput: function (field, value) {
                if (typeof value !== 'string') return value;

                var maxLengths = {
                    'benefits': 500, 'red-flags': 500, 'healthy': 500, 'glp-before': 100,
                    'medication-tried': 500, 'current-medication': 500, 'recent-dose': 1000,
                    'body-composition': 500, 'goal': 500, 'lifestyle': 100, 'willing': 100,
                    'gallbladder': 100, 'eating-disorder': 200, 'consent': 100,
                    'phone': 20, 'dob': 10, 'id_photo_base64': 14000000
                };

                if (maxLengths[field] && value.length > maxLengths[field]) {
                    /* Campo excede longitud máxima */
                    return value.substring(0, maxLengths[field]);
                }

                var sanitized = value.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
                    .replace(/javascript:/gi, '')
                    .replace(/on\w+\s*=/gi, '')
                    .replace(/expression\(/gi, '');

                switch (field) {
                    case 'phone':
                        sanitized = sanitized.replace(/[^\d\s\(\)\-]/g, '');
                        break;
                    case 'dob':
                        if (!/^\d{4}-\d{2}-\d{2}$/.test(sanitized)) {
                            throw new Error('Invalid date format');
                        }
                        break;
                    case 'id_photo_base64':
                        if (!/^data:image\/(jpeg|png|jpg);base64,/.test(sanitized)) {
                            throw new Error('Invalid image format');
                        }
                        break;
                }

                return sanitized;
            }
        };



        // ==========================================
        // OBJETO PRINCIPAL QZ
        // ==========================================
        window.QZ = {
            stepIndex: 0,
            currentRoute: [],
            isReturning: false,
            intakeCompleted: false,
            isSubmitting: false,
            userData: { answers: {}, orderContext: {}, customer: {} },

            KNOCKOUT_RULES: {
                'state': {}
            },

            QUESTION_MAP: {
                'fname': 'First Name', 'lname': 'Last Name', 'email': 'Email Address', 'phone': 'Phone Number',
                'state': 'State of Residence', 'bmi_metrics': 'Body Metrics (Height/Weight)', 'dob': 'Date of Birth',
                'sex': 'Biological Sex', 'Pregnancy_And_Hormonal_Status': 'Pregnancy & Hormonal Status', 'Menopause_Stage': 'Menopause Stage',
                'activity': 'Activity Level', 'diet': 'Dietary Habits', 'History_of_Cancer': 'History of Cancer',
                'Diabetes_Insulin_Resistance_History': 'Diabetes / Insulin Resistance History', 'Cardiovascular_History': 'Cardiovascular History',
                'Thyroid_Conditions': 'Thyroid Conditions', 'autoimmune': 'Auto-immune Conditions', 'mental': 'Mental Health History',
                'neuro': 'Neurological Conditions', 'musculo': 'Musculoskeletal Conditions', 'digestive': 'Digestive Conditions',
                'blood': 'Blood Preasure', 'cholesterol': 'Cholesterol Options', 'lifestyle_factors': 'Family Factors Options',
                'family': 'Family History', 'surgeries': 'Past Surgeries', 'meds_supplements': 'Vitamins & Supplements', 'meds_rx': 'Prescription Medications',
                'med_conditions': 'Medical Conditions', 'marketing_source': 'Marketing Source', 'marketing_details': 'Marketing Referral Details',
                'marketing_details': 'Marketing Referral Details', 'med_conditions_details': 'Other Medical Conditions Details'
            },

            OTHER_MAP: {
                'mental': { title: 'You selected "Other" for Mental Health Conditions', sub: "Please specify." },
                'Thyroid_Conditions': { title: 'You selected "Other" for Thyroid Condition', sub: "Please specify." },
                'Diabetes_Insulin_Resistance_History': { title: 'Diabetes Details', sub: "Please specify." },
                'Cardiovascular_History': { title: 'You selected "Other" for Cardiovascular Disease', sub: "Please specify." },
                'autoimmune': { title: 'You selected "Other" for Auto-Immune Condition', sub: "Please specify." },
                'neuro': { title: 'You selected "Other" for Neurological Disorders', sub: "Please specify." },
                'musculo': { title: 'You selected "Other" for Musculoskeletal Disorders', sub: "Please specify." },
                'digestive': { title: 'You selected "Other" for Digestive Disorders', sub: "Please specify." },
                'family': {
                    title: "Family History Details",
                    sub: "Please quickly describe your family medical history of <strong style='color:#12315E;'>__selected__</strong>.",
                    styles: { title: "font-size: 24px !important;", sub: "margin-bottom: 20px;" }
                },
                'med-conditions': {
                    title: "Please describe your other medical conditions not previously mentioned:",
                    sub: "",
                    styles: { title: "font-size: 22px !important; margin-bottom: 15px;", sub: "" }
                },
                'History_of_Cancer': {
                    title: "Cancer History Details",
                    sub: "Please provide details about your cancer history including type, diagnosis date, and current status.",
                    styles: { title: "font-size: 22px !important; margin-bottom: 15px;", sub: "margin-bottom: 20px;" }
                }
            },

            EXEMPT_VARIANT_IDS: [],
            bypassIntakeCompleted: false,

            AGREEMENT_RULES: {
                'Diabetes_Insulin_Resistance_History': {
                    'Insulin Resistance': {
                        title: "⚠️",
                        sub: "Some protocols we offer may impact blood sugar levels and regulation, which is more relevant for those with pre-diabetes and insulin resistance.<br><br>We'll ask additional questions on the medication-specific forms to evaluate your suitability for these medications.",
                        btnAgree: "I Understand & Agree",
                        btnDisagree: "I Don't Agree",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    },
                    'Pre-Diabetes': {
                        title: "⚠️",
                        sub: "Some protocols we offer may impact blood sugar levels and regulation, which is more relevant for those with pre-diabetes and insulin resistance.<br><br>We'll ask additional questions on the medication-specific forms to evaluate your suitability for these medications.",
                        btnAgree: "I Understand & Agree",
                        btnDisagree: "I Don't Agree",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    },
                    'Type 1': {
                        title: "⚠️",
                        sub: "Not all programs are available for Type 1 or Type 2 diabetics.<br><br>We'll ask additional questions on the medication-specific forms to evaluate your suitability for these specific medications.",
                        btnAgree: "I Understand & Agree",
                        btnDisagree: "I Don't Agree",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    },
                    'Type 2': {
                        title: "⚠️",
                        sub: "Not all programs are available for Type 1 or Type 2 diabetics.<br><br>We'll ask additional questions on the medication-specific forms to evaluate your suitability for these specific medications.",
                        btnAgree: "I Understand & Agree",
                        btnDisagree: "I Don't Agree",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    },
                },
                'Thyroid_Conditions': {
                    'Hypothyroidism': {
                        title: "⚠️",
                        sub: " Thyroid conditions may influence energy and metabolism, and some Levers protocols can affect these systems. We will ask additional questions when relevant in the medication-specific forms.<br><br>You agree to monitor symptoms, continue regular thyroid follow-up with your provider, and notify Levers if you experience any changes or worsening symptoms.",
                        btnAgree: "I Understand & Agree",
                        btnDisagree: "Decline Treatment",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    },
                    'Hyperthyroidism': {
                        title: "⚠️",
                        sub: " Thyroid conditions may influence energy and metabolism, and some Levers protocols can affect these systems. We will ask additional questions when relevant in the medication-specific forms.<br><br>You agree to monitor symptoms, continue regular thyroid follow-up with your provider, and notify Levers if you experience any changes or worsening symptoms.",
                        btnAgree: "I Understand & Agree",
                        btnDisagree: "Decline Treatment",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    },
                    'Thyroid Removal': {
                        title: "⚠️",
                        sub: " Thyroid conditions may influence energy and metabolism, and some Levers protocols can affect these systems. We will ask additional questions when relevant in the medication-specific forms.<br><br>You agree to monitor symptoms, continue regular thyroid follow-up with your provider, and notify Levers if you experience any changes or worsening symptoms.",
                        btnAgree: "I Understand & Agree",
                        btnDisagree: "Decline Treatment",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    },
                    'Thyroid Tumors (non-cancerous)': {
                        title: "⚠️",
                        sub: " Thyroid conditions may influence energy and metabolism, and some Levers protocols can affect these systems. We will ask additional questions when relevant in the medication-specific forms.<br><br>You agree to monitor symptoms, continue regular thyroid follow-up with your provider, and notify Levers if you experience any changes or worsening symptoms.",
                        btnAgree: "I Understand & Agree",
                        btnDisagree: "Decline Treatment",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    },
                    'Thyroiditis (Hashimotos or Post-Partum)': {
                        title: "⚠️",
                        sub: " Thyroid conditions may influence energy and metabolism, and some Levers protocols can affect these systems. We will ask additional questions when relevant in the medication-specific forms.<br><br>You agree to monitor symptoms, continue regular thyroid follow-up with your provider, and notify Levers if you experience any changes or worsening symptoms.",
                        btnAgree: "I Understand & Agree",
                        btnDisagree: "Decline Treatment",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    },
                    'Goiter': {
                        title: "⚠️",
                        sub: " Thyroid conditions may influence energy and metabolism, and some Levers protocols can affect these systems. We will ask additional questions when relevant in the medication-specific forms.<br><br>You agree to monitor symptoms, continue regular thyroid follow-up with your provider, and notify Levers if you experience any changes or worsening symptoms.",
                        btnAgree: "I Understand & Agree",
                        btnDisagree: "Decline Treatment",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    }
                },
                'History_of_Cancer': {
                    'Prior cancer, in remission': {
                        title: "⚠️",
                        sub: "Not all protocols we offer are available to those with active or prior cancer.<br><br>We'll ask additional questions on the medication-specific forms to evaluate your suitability for these medications.",
                        btnAgree: "I understand and agree",
                        btnDisagree: "Exit Form & Refund",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    },
                    'Active cancer': {
                        title: "⚠️",
                        sub: "Not all protocols we offer are available to those with active or prior cancer.<br><br>We'll ask additional questions on the medication-specific forms to evaluate your suitability for these medications.",
                        btnAgree: "I understand and agree",
                        btnDisagree: "Exit Form & Refund",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    }
                },
                'Pregnancy_And_Hormonal_Status': {
                    'Pregnant': {
                        title: "⚠️",
                        sub: "Not all programs are available for pregnant women, and/or some products should be discontinued upon conception. <br><br>Your provider will evaluate your selected program and will follow up with more info as needed.<br><br>If you are not approved for a given program, your order will be refunded. Upon awareness of conception, you agree to discontinue protocols that are not studied during pregnancy.",
                        btnAgree: "I understand and agree",
                        btnDisagree: "I don't agree",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    },
                    'Trying to conceive': {
                        title: "⚠️",
                        sub: "Not all programs are available for pregnant women, and/or some products should be discontinued upon conception. <br><br>Your provider will evaluate your selected program and will follow up with more info as needed.<br><br>If you are not approved for a given program, your order will be refunded. Upon awareness of conception, you agree to discontinue protocols that are not studied during pregnancy.",
                        btnAgree: "I understand and agree",
                        btnDisagree: "I don't agree",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    }
                },
                'Menopause_Stage': {
                    'Menopause': {
                        title: "⚠️",
                        sub: "Not all programs are available for pregnant women, and/or some products should be discontinued upon conception. <br><br>Your provider will evaluate your selected program and will follow up with more info as needed.<br><br>If you are not approved for a given program, your order will be refunded. Upon awareness of conception, you agree to discontinue protocols that are not studied during pregnancy.",
                        btnAgree: "I understand and agree",
                        btnDisagree: "I don't agree",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    },
                    'Perimenopause': {
                        title: "⚠️",
                        sub: "Not all programs are available for pregnant women, and/or some products should be discontinued upon conception. <br><br>Your provider will evaluate your selected program and will follow up with more info as needed.<br><br>If you are not approved for a given program, your order will be refunded. Upon awareness of conception, you agree to discontinue protocols that are not studied during pregnancy.",
                        btnAgree: "I understand and agree",
                        btnDisagree: "ExiI don't agreet",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    },
                    'Post-Menopause': {
                        title: "⚠️",
                        sub: "Not all programs are available for pregnant women, and/or some products should be discontinued upon conception. <br><br>Your provider will evaluate your selected program and will follow up with more info as needed.<br><br>If you are not approved for a given program, your order will be refunded. Upon awareness of conception, you agree to discontinue protocols that are not studied during pregnancy.",
                        btnAgree: "I understand and agree",
                        btnDisagree: "I don't agree",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    },
                    'Premenopause': {
                        title: "⚠️",
                        sub: "Not all programs are available for pregnant women, and/or some products should be discontinued upon conception. <br><br>Your provider will evaluate your selected program and will follow up with more info as needed.<br><br>If you are not approved for a given program, your order will be refunded. Upon awareness of conception, you agree to discontinue protocols that are not studied during pregnancy.",
                        btnAgree: "I understand and agree",
                        btnDisagree: "I don't agree",
                        redirectUrl: "https://levers.health",
                        knockout: {
                            title: "Consultation Stopped",
                            sub: "<strong>We are sorry!</strong><br><br>To proceed with your order, you must accept this agreement, you can request a refund on the button below, if so, it will processed within 24 hours",
                            msg: ""
                        }
                    }
                }
            },

            BMI_RULES: { 'Microdose': 19, 'Low-Dose': 22, 'Low Dose': 22, 'DEFAULT': 25 },

            // ==========================================
            // PRODUCT STATE RESTRICTION LOGIC
            // ==========================================
            productIds: [],
            restrictedProducts: [],
            allowedProducts: [],

            // Verifica qué productos no están permitidos en el estado seleccionado
            // Retorna: 'all_restricted' | 'some_restricted' | 'none_restricted'
            checkProductStateRestrictions: function (selectedState) {
                this.restrictedProducts = [];
                this.allowedProducts = [];

                if (!this.productIds || this.productIds.length === 0) {
                    return 'none_restricted';
                }

                var self = this;
                this.productIds.forEach(function (productId, index) {
                    var productInfo = PRODUCT_REGISTRY[productId];
                    
                    // Si el producto está en el registro, verificar estados permitidos
                    if (productInfo && productInfo.allowedStates) {
                        var isAllowed = productInfo.allowedStates.some(function (state) {
                            return state.toLowerCase() === selectedState.toLowerCase();
                        });

                        if (!isAllowed) {
                            self.restrictedProducts.push({
                                id: productId,
                                name: productInfo.name || 'Unknown Product'
                            });
                        } else {
                            self.allowedProducts.push({
                                id: productId,
                                name: productInfo.name || 'Unknown Product'
                            });
                        }
                    } else {
                        // Si el producto no está en el registro, se asume permitido en todos los estados
                        self.allowedProducts.push({
                            id: productId,
                            name: 'Product ' + productId
                        });
                    }
                });

                if (this.restrictedProducts.length === 0) {
                    return 'none_restricted';
                } else if (this.allowedProducts.length === 0) {
                    return 'all_restricted';
                } else {
                    return 'some_restricted';
                }
            },

            // Renderiza la lista de productos restringidos en el step
            renderRestrictedProducts: function () {
                var self = this;
                var container = document.getElementById('qz-restricted-products-list');
                var stateName = document.getElementById('qz-restriction-state-name');

                if (stateName) {
                    stateName.innerText = this.userData.answers['state'] || 'your state';
                }

                if (!container) return;

                container.innerHTML = '';

                this.restrictedProducts.forEach(function (product) {
                    var item = document.createElement('div');
                    item.className = 'qz-option';
                    item.innerHTML = 
                        '<div class="qz-checkbox"></div>' +
                        '<span>' + self.escapeHtml(product.name) + '</span>';
                    container.appendChild(item);
                });
            },

            // Procesa refund parcial y continúa
            processPartialRefund: function () {
                var self = this;
                var productIdsToRefund = this.restrictedProducts.map(function (p) { return p.id; });

                var payload = {
                    ts: new Date().toISOString(),
                    order_id: this.urlOrderId || this.userData.orderContext.orderId || "unknown",
                    client: {
                        fn: this.userData.customer.first_name || "",
                        ln: this.userData.customer.last_name || "",
                        em: this.userData.customer.email || "",
                        ph: this.userData.customer.phone || ""
                    },
                    refund_type: 'partial',
                    product_ids: productIdsToRefund,
                    restricted_product_names: this.restrictedProducts.map(function (p) { return p.name; }),
                    selected_state: this.userData.answers['state'],
                    _nonce: Date.now().toString(36) + Math.random().toString(36).substr(2)
                };

                fetch(CONFIG.WEBHOOK_REFUND, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Request-Nonce': payload._nonce
                    },
                    body: JSON.stringify(payload)
                })
                .then(function (res) {
                    if (!res.ok) throw new Error("Status " + res.status);
                    return res.text();
                })
                .then(function () {
                    // Guardar los productos restringidos como "refundeados"
                    self.userData.answers['refunded_product_ids'] = productIdsToRefund;
                    self.userData.answers['refund_type'] = 'partial';
                    
                    // Remover los productos restringidos de la lista
                    self.productIds = self.productIds.filter(function (id) {
                        return !productIdsToRefund.includes(id);
                    });

                    // Limpiar restricciones
                    self.restrictedProducts = [];

                    // Recalcular ruta y actualizar UI
                    // No usamos next() porque el paso actual (restriction) desaparece de la ruta
                    // Al recalcular, el stepIndex actual apuntará al siguiente paso lógico
                    self.calculateRoute();
                    self.saveToSession();
                    self.updateUI();
                })
                .catch(function (err) {
                    /* Refund webhook error */
                    self.showSystemError();
                });
            },

            // Muestra knockout antes de refund completo
            showFullRefundKnockout: function () {
                var self = this;
                var productNames = this.restrictedProducts.map(function (p) { return p.name; }).join(', ');
                
                this.showKnockout(
                    "Cancel Order",
                    "Full Refund Request",
                    "You are about to cancel your entire order and request a full refund for all products.\n\n" +
                    "This action cannot be undone.\n\n" +
                    "If you only want to remove the restricted items (" + productNames + ") and continue with eligible products, please go back and select \"Continue With Eligible Products\" instead.",
                    true,
                    "REFUND_ALL"
                );

                // Configurar el botón de exit para procesar refund completo
                var exitBtn = document.getElementById('qz-knockout-exit');
                if (exitBtn) {
                    exitBtn.onclick = function () {
                        self.processFullRefund();
                    };
                    exitBtn.innerHTML = '<span>Confirm & Cancel Order</span>';
                }
            },

            // Procesa refund completo
            processFullRefund: function () {
                var self = this;
                var exitBtn = document.getElementById('qz-knockout-exit');
                
                if (exitBtn) {
                    exitBtn.disabled = true;
                    exitBtn.innerHTML = '<span>Processing...</span>';
                }

                var payload = {
                    ts: new Date().toISOString(),
                    order_id: this.urlOrderId || this.userData.orderContext.orderId || "unknown",
                    client: {
                        fn: this.userData.customer.first_name || "",
                        ln: this.userData.customer.last_name || "",
                        em: this.userData.customer.email || "",
                        ph: this.userData.customer.phone || ""
                    },
                    refund_type: 'all',
                    product_ids: this.productIds,
                    restricted_product_names: this.restrictedProducts.map(function (p) { return p.name; }),
                    selected_state: this.userData.answers['state'],
                    _nonce: Date.now().toString(36) + Math.random().toString(36).substr(2)
                };

                fetch(CONFIG.WEBHOOK_REFUND, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Request-Nonce': payload._nonce
                    },
                    body: JSON.stringify(payload)
                })
                .then(function (res) {
                    if (!res.ok) throw new Error("Status " + res.status);
                    return res.text();
                })
                .then(function () {
                    if (exitBtn) {
                        exitBtn.innerHTML = '<span>Refund Processed ✓</span>';
                    }
                    setTimeout(function () {
                        window.location.href = "https://levers.health";
                    }, 2000);
                })
                .catch(function (err) {
                    /* Refund webhook error */
                    if (exitBtn) {
                        exitBtn.disabled = false;
                        exitBtn.innerHTML = '<span>Try Again</span>';
                    }
                    self.showSystemError();
                });
            },

            // ==========================================
            // FUNCIONES CORE
            // ==========================================

            attemptNext: function (stepId, customFnName) {
                var genericValid = this.validateGeneric(stepId);
                if (!genericValid) {
                    return false;
                }

                if (customFnName && typeof this[customFnName] === 'function') {
                    var customResult = this[customFnName](stepId);
                    if (customResult === false) {
                        return false;
                    }
                }

                this.next();
                return true;
            },

            validateGeneric: function (stepId) {
                var stepEl = document.getElementById(stepId);
                if (!stepEl) return true;
                var inputs = stepEl.querySelectorAll('[data-required="true"]');
                var isValid = true;
                var self = this;
                inputs.forEach(function (input) {
                    var val = input.value.trim();
                    var id = input.id;
                    if (!val) {
                        self.showError(id, 'This field is required');
                        isValid = false;
                    } else if (input.getAttribute('data-type') === 'email') {
                        var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                        if (!emailRegex.test(val)) {
                            self.showError(id, 'Please enter a valid email');
                            isValid = false;
                        }
                    }
                });
                return isValid;
            },

            formatPhoneNumber: function (input) {
                this.clearError('qz-phone');
                const container = document.getElementById('qz-phone-container');
                if (container) container.classList.remove('input-error');

                let num = input.value.replace(/\D/g, '');
                if (num.length > 10) num = num.substring(0, 10);

                let formatted = "";
                if (num.length > 0) {
                    formatted = "(" + num.substring(0, 3);
                    if (num.length > 3) {
                        formatted += ") " + num.substring(3, 6);
                    }
                    if (num.length > 6) {
                        formatted += "-" + num.substring(6, 10);
                    }
                }
                input.value = formatted;
            },

            saveContactData: function () {
                var fInput = document.getElementById('qz-fname');
                var lInput = document.getElementById('qz-lname');
                var eInput = document.getElementById('qz-email');
                var pInput = document.getElementById('qz-phone');

                if (!fInput || !lInput || !eInput || !pInput) {
                    /* Critical: Missing input fields in DOM */
                    return false;
                }

                var f = fInput.value.trim();
                var l = lInput.value.trim();
                var e = eInput.value.trim();
                var p = pInput.value.trim();

                var isValid = true;

                var phoneContainer = document.getElementById('qz-phone-container');
                if (phoneContainer) phoneContainer.classList.remove('input-error');

                if (!f || f.length < 2) {
                    this.showError('qz-fname', 'Please enter your First Name');
                    isValid = false;
                }
                if (!l || l.length < 2) {
                    this.showError('qz-lname', 'Please enter your Last Name');
                    isValid = false;
                }

                var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                if (!e || !emailRegex.test(e)) {
                    this.showError('qz-email', 'Please enter a valid email address');
                    isValid = false;
                }

                var cleanPhone = p.replace(/\D/g, '');
                if (!p || cleanPhone.length < 10) {
                    this.showError('qz-phone', 'Please enter a valid 10-digit phone number');
                    if (phoneContainer) phoneContainer.classList.add('input-error');
                    isValid = false;
                }

                if (!isValid) return false;

                var prefix = "+1";

                this.userData.customer = {
                    first_name: f,
                    last_name: l,
                    email: e,
                    phone: prefix + cleanPhone,
                    display_phone: prefix + " " + p
                };

                this.saveToSession();

                return true;
            },

            runWithFeedback: function (btn, fnName) {
                if (!btn || btn.disabled) return;
                
                btn.classList.add('qz-btn-processing');
                btn.disabled = true;
                
                var self = this;
                var args = Array.prototype.slice.call(arguments, 2);
                
                // Funciones que requieren manejo especial post-ejecución
                var isRedirectFn = fnName === 'redirectTo' || fnName === 'proceedToProductForms';
                // Funciones que manejan sus propios estados de botón
                var selfManagedFns = ['submitFromThankYou', 'handleKnockoutExit', 'processPartialRefund', 'processFullRefund'];
                
                setTimeout(function () {
                    try {
                        if (typeof self[fnName] === 'function') {
                            self[fnName].apply(self, args);
                        } else if (fnName === 'redirectTo' && args[0]) {
                            window.location.href = args[0];
                        }
                    } catch (e) {
                        /* Error executing function */
                        // Restaurar botón en caso de error
                        btn.classList.remove('qz-btn-processing');
                        btn.disabled = false;
                    }
                    
                    // Restaurar botón después de un delay (excepto redirecciones y funciones auto-gestionadas)
                    if (!isRedirectFn && selfManagedFns.indexOf(fnName) === -1) {
                        setTimeout(function() {
                            if (!btn.disabled) return; // Ya fue restaurado
                            btn.classList.remove('qz-btn-processing');
                            btn.disabled = false;
                        }, 300);
                    }
                }, 350);
            },
            
            redirectTo: function(url) {
                if (url && typeof url === 'string') {
                    window.location.href = url;
                }
            },
            
            handleKnockoutExit: function() {
                var exitBtn = document.getElementById('qz-knockout-exit');
                if (exitBtn && exitBtn.onclick) {
                    // Ejecutar el handler original que fue configurado dinámicamente
                    exitBtn.onclick();
                } else {
                    this.redirectTo('https://levers.health');
                }
            },

            // ==========================================
            // INIT & LÓGICA PHOENIX
            // ==========================================

            // DOM Cache para elementos frecuentemente accedidos
            DOM: {},
            INPUTS: {},
            debounceTimers: {},

            init: function () {
                var self = this;
                var params = new URLSearchParams(window.location.search);
                var orderId = params.get('order_id');
                this.urlOrderId = orderId;

                // CACHE DOM ELEMENTS
                this.DOM = {
                    wrapper: document.getElementById('qz-wrapper'),
                    loader: document.getElementById('qz-loader'),
                    barFill: document.getElementById('qz-bar-fill'),
                    header: document.querySelector('.qz-header'),
                    backBtn: document.getElementById('qz-back-btn'),
                    steps: document.querySelectorAll('.qz-step'),
                    knockoutOverlay: document.getElementById('qz-knockout-overlay'),
                    processingOverlay: document.getElementById('qz-processing-overlay')
                };

                // CACHE INPUTS FRECUENTES
                this.INPUTS = {
                    fname: document.getElementById('qz-fname'),
                    lname: document.getElementById('qz-lname'),
                    email: document.getElementById('qz-email'),
                    phone: document.getElementById('qz-phone'),
                    ft: document.getElementById('qz-ft'),
                    inches: document.getElementById('qz-in'),
                    lbs: document.getElementById('qz-lbs'),
                    dobYear: document.getElementById('dob-year'),
                    dobMonth: document.getElementById('dob-month'),
                    dobDay: document.getElementById('dob-day'),
                    stateSelect: document.getElementById('qz-state-select')
                };

                this.hideProcessingOverlay();
                this.setupUIHelpers();

                this.applySecurityShield();

                // ✅ BYPASS HIPAA-COMPLIANT: Verificar si es actualización via URL param
                var updateParam = params.get('update');
                if (updateParam === 'true') {
                    this.bypassIntakeCompleted = true;
                    // Cuando es actualización, tratar como paciente nuevo para mostrar todos los steps
                    this.isReturning = false;
                    this.userData.isReturning = false;
                    // Limpiar cualquier dato previo del navegador por seguridad HIPAA
                    try {
                        sessionStorage.removeItem('levers_form_draft');
                        this.userData.answers = {};
                    } catch (e) { }
                }

                if (!orderId) {
                    this.showKnockout(
                        "Order Required",                           // title
                        "Medical Warning",                                       // subtitle (nuevo parámetro)
                        "This form requires a valid purchase to access. Please complete your purchase before filling out this form.", // message
                        false,                                      // showBackButton
                        "https://levers.health/collections/all"     // exitUrl
                    );
                    return;
                }

                this.fetchRealOrderData(orderId).then(function (data) {
                    self.processOrderContext(data);
                    self.updateProductDisplay();
                    
                    // ✅ PRIORIDAD: Si la orden está refundeada, mostrar paso de refund inmediatamente
                    if (self.isRefunded) {
                        self.hideLoader();
                        self.calculateRoute();
                        self.updateUI();
                        return;
                    }
                    
                    var isKnockedOut = self.evaluatePreloadRules();
                    if (!isKnockedOut) {
                        self.hideLoader();
                        self.calculateRoute();
                        self.updateUI();
                    }
                }).catch(function (err) {
                    /* Error fetching order data */
                    self.hideLoader();
                    self.showSystemError();
                });

                this.initOptimizations();
                
                // ✅ NUCLEAR: Asegurar que el botón de update esté oculto desde el inicio
                var updateBtn = document.getElementById('qz-update-info-btn');
                if (updateBtn) {
                    updateBtn.classList.remove('is-visible');
                    updateBtn.removeAttribute('data-show');
                }
            },

            hideProcessingOverlay: function () {
                var overlay = document.getElementById('qz-processing-overlay');
                if (overlay) overlay.classList.remove('is-active');
            },

            initOptimizations: function () {
                // Optimizaciones adicionales se pueden agregar aquí
            },

            updateProductDisplay: function () {
                // Placeholder para actualizar display de productos
            },

            evaluatePreloadRules: function () {
                // Placeholder para reglas de precarga
                return false;
            },

            showSystemError: function () {
                var title = "System Unavailable";
                var subtitle = "Connection Error";
                var msg = "Our servers are currently experiencing issues or your connection was interrupted. Please try again in a moment or refresh the page.";
                
                this.showKnockout(
                    title,
                    subtitle,
                    msg,
                    false, // showBackButton
                    window.location.href // exitUrl (refresh page)
                );
                
                // Customize exit button for refresh context
                var exitBtn = document.getElementById('qz-knockout-exit');
                if (exitBtn) {
                   exitBtn.innerHTML = "<span>Refresh Page</span>";
                }
            },

            decodeEntities: function (str) {
                if (!str) return str;
                var txt = document.createElement("textarea");
                txt.innerHTML = str;
                return txt.value;
            },

            compressImage: function (file, maxWidth, quality) {
                var self = this;
                return new Promise(function (resolve, reject) {
                    if (!file) { resolve(null); return; }
                    if (typeof file.type !== 'string' || file.type.indexOf('image') === -1) {
                        /* Archivo no es imagen */
                        resolve(file);
                        return;
                    }

                    try {
                        var reader = new FileReader();
                        reader.readAsDataURL(file);

                        reader.onload = function (event) {
                            var img = new Image();
                            img.src = event.target.result;

                            img.onload = function () {
                                try {
                                    var width = img.width;
                                    var height = img.height;
                                    if (width > maxWidth) {
                                        height = Math.round(height * (maxWidth / width));
                                        width = maxWidth;
                                    }

                                    var canvas = document.createElement('canvas');
                                    canvas.width = width;
                                    canvas.height = height;
                                    var ctx = canvas.getContext('2d');
                                    ctx.drawImage(img, 0, 0, width, height);

                                    canvas.toBlob(function (blob) {
                                        if (!blob) {
                                            /* Falló la generación del Blob */
                                            resolve(file);
                                            return;
                                        }
                                        resolve({
                                            isCompressed: true,
                                            blob: blob,
                                            name: file.name.replace(/\.[^/.]+$/, "") + ".jpg"
                                        });
                                    }, 'image/jpeg', quality);

                                } catch (err) {
                                    /* Error durante el renderizado */
                                    resolve(file);
                                }
                            };

                            img.onerror = function () {
                                /* Imagen corrupta */
                                resolve(file);
                            };
                        };

                        reader.onerror = function () {
                            /* Error leyendo archivo */
                            resolve(file);
                        };

                    } catch (e) {
                        /* Error crítico en compresor */
                        resolve(file);
                    }
                });
            },

            formatUniversalLabel: function (key) {
                if (!key) return "Unknown Field";
                if (this.QUESTION_MAP[key]) return this.QUESTION_MAP[key];

                return key
                    .replace(/_/g, ' ')
                    .replace(/-/g, ' ')
                    .replace(/([A-Z])/g, ' $1')
                    .replace(/\w\S*/g, function (txt) {
                        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                    })
                    .trim();
            },

            prepareGeneralPayload: function () {
                var responses = {};
                var self = this;
                var answers = this.userData.answers;

                if (!answers || Object.keys(answers).length === 0) {
                    try { sessionStorage.removeItem('levers_form_draft'); } catch (e) { }
                    return null;
                }

                for (var key in answers) {
                    if (!answers.hasOwnProperty(key)) continue;
                    
                    var rawVal = answers[key];
                    if (rawVal == null || rawVal === '') continue;

                    // ✅ CASO ESPECIAL 1: bmi_metrics (objeto con ft, in, lbs, bmi)
                    if (key === 'bmi_metrics' && typeof rawVal === 'object') {
                        if (rawVal.ft != null) responses['height_feet'] = String(rawVal.ft);
                        if (rawVal.in != null) responses['height_inches'] = String(rawVal.in);
                        if (rawVal.lbs != null) responses['weight_lbs'] = String(rawVal.lbs);
                        if (rawVal.bmi != null) responses['bmi'] = String(rawVal.bmi);
                        continue;
                    }

                    // ✅ CASO ESPECIAL 2: conditional (objeto existente)
                    if (key === 'conditional' && typeof rawVal === 'object') {
                        for (var condKey in rawVal) {
                            if (!rawVal.hasOwnProperty(condKey)) continue;
                            try {
                                responses[condKey] = self.decodeEntities(
                                    SecurityUtils.validateMedicalInput(condKey, rawVal[condKey])
                                );
                            } catch (err) {
                                /* Validation failed */
                                throw new Error('Invalid input: ' + condKey);
                            }
                        }
                        continue;
                    }

                    // ✅ CASO 3: agreements_accepted -> Mantener como array
                    if (key === 'agreements_accepted' && Array.isArray(rawVal)) {
                        responses[key] = rawVal;
                        continue;
                    }

                    // ✅ CASO 4: Arrays -> convertir a string separado por comas
                    if (Array.isArray(rawVal) && rawVal.length > 0) {
                        var finalString = rawVal.filter(function (v) { return v && v !== ""; }).join(', ');
                        if (finalString) {
                            try {
                                responses[key] = self.decodeEntities(
                                    SecurityUtils.validateMedicalInput(key, finalString)
                                );
                            } catch (err) {
                                /* Validation failed */
                                throw new Error('Invalid input: ' + key);
                            }
                        }
                        continue;
                    }

                    // ✅ CASO 5: Strings → sanitizar
                    if (typeof rawVal === 'string') {
                        if (key === 'id_photo_base64') {
                            responses[key] = rawVal; // Sin sanitización
                        } else {
                            try {
                                var sanitized = SecurityUtils.validateMedicalInput(key, rawVal)
                                    .replace(/&/g, '&amp;')
                                    .replace(/</g, '&lt;')
                                    .replace(/>/g, '&gt;')
                                    .replace(/"/g, '&quot;')
                                    .replace(/'/g, '&#39;');
                                responses[key] = sanitized;
                            } catch (err) {
                                /* Validation failed */
                                throw new Error('Invalid input: ' + key);
                            }
                        }
                        continue;
                    }

                    // ✅ CASO 6: Booleanos y Números → convertir a string
                    if (typeof rawVal === 'boolean' || typeof rawVal === 'number') {
                        responses[key] = String(rawVal);
                    }
                }

                var urlParams = new URLSearchParams(window.location.search);
                var urlOrderId = urlParams.get('order_id');
                var internalId = (this.userData.orderContext && this.userData.orderContext.orderId) ?
                    this.userData.orderContext.orderId : null;
                var finalOrderId = (urlOrderId && urlOrderId !== "" && urlOrderId !== "null") ?
                    urlOrderId : (internalId && internalId !== "from_webhook" ?
                        internalId : "from_webhook");

                return {
                    ts: new Date().toISOString(),
                    order_id: finalOrderId,
                    oid: finalOrderId,
                    client: {
                        fn: this.userData.customer.first_name || "",
                        ln: this.userData.customer.last_name || "",
                        em: this.userData.customer.email || "",
                        ph: this.userData.customer.phone || ""
                    },
                    responses: responses
                };
            },

            blobToBase64: function (blob) {
                return new Promise(function (resolve, reject) {
                    const reader = new FileReader();
                    reader.onloadend = function () { resolve(reader.result); };
                    reader.readAsDataURL(blob);
                });
            },

            submitAndRedirect: function (btn) {
                var self = this;

                // Feedback visual
                btn.classList.add('qz-btn-processing');
                btn.disabled = true;
                btn.innerHTML = '<span>Submitting...</span>';

                // 1. ENVIAR A N8N
                this.submitGeneralIntake();

                // NOTA: submitGeneralIntake ya maneja el éxito con next() y startAutoRedirect()
                // Pero nosotros queremos controlar la redirección manualmente

                // Modificación: necesitamos saber cuándo termina el submit
            },

            submitGeneralIntake: function (onSuccessCallback) {
                var self = this;
                var overlay = document.getElementById('qz-processing-overlay');

                if (overlay) overlay.classList.add('is-active');

                if (this.isSubmitting) return Promise.reject('Already submitting');
                this.isSubmitting = true;

                var payload = this.prepareGeneralPayload();

                if (!payload) {
                    this.isSubmitting = false;
                    if (overlay) overlay.classList.remove('is-active');
                    return Promise.reject('No payload');
                }

                payload._nonce = Date.now().toString(36) + Math.random().toString(36).substr(2);

                var fetchOptions = {
                    method: 'POST',
                    mode: 'cors',
                    credentials: 'omit',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Request-Nonce': payload._nonce
                    },
                    body: JSON.stringify(payload)
                };

                function doSubmit(url, isFallback) {
                    return fetch(url, fetchOptions)
                        .then(function (res) {
                            if (!res.ok) throw new Error("HTTP " + res.status);
                            return res.text();
                        })
                        .then(function (text) {

                            try {
                                sessionStorage.removeItem('levers_form_draft');
                            } catch (e) { }

                            self.isSubmitting = false;
                            if (overlay) overlay.classList.remove('is-active');

                            // Ejecutar callback si existe
                            if (typeof onSuccessCallback === 'function') {
                                onSuccessCallback();
                            }

                            return text;
                        })
                        .catch(function (err) {
                            if (!isFallback && CONFIG.WEBHOOK_SUBMIT_FALLBACK) {
                                return doSubmit(CONFIG.WEBHOOK_SUBMIT_FALLBACK, true);
                            }
                            /* Submit error (primary and fallback failed) */
                            self.isSubmitting = false;
                            if (overlay) overlay.classList.remove('is-active');
                            self.showSystemError();
                            throw err;
                        });
                }

                return doSubmit(CONFIG.WEBHOOK_SUBMIT, false);
            },

            submitRefundRequest: function (reason) {
                var self = this;
                var refundBtn = document.getElementById('qz-knockout-exit');
                if (!reason) reason = "Medical Agreement Disagree";

                if (refundBtn) {
                    refundBtn.disabled = true;
                    refundBtn.innerHTML = '<span>Processing...</span>';
                }

                /* Initiating refund request */

                var payload = {
                    ts: new Date().toISOString(),
                    order_id: this.urlOrderId || "manual_refund",
                    client: {
                        fn: this.userData.customer.first_name || "",
                        ln: this.userData.customer.last_name || "",
                        em: this.userData.customer.email || "",
                        ph: this.userData.customer.phone || ""
                    },
                    refund_reason: reason,
                    _nonce: Date.now().toString(36) + Math.random().toString(36).substr(2)
                };

                fetch(CONFIG.WEBHOOK_REFUND, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Request-Nonce': payload._nonce
                    },
                    body: JSON.stringify(payload)
                })
                .then(function(res) {
                    if (!res.ok) throw new Error("Status " + res.status);
                    return res.text();
                })
                .then(function() {
                    if (refundBtn) refundBtn.innerHTML = '<span>Refund Requested ✓</span>';
                    setTimeout(function() {
                        window.location.href = "https://levers.health";
                    }, 2000);
                })
                .catch(function(err) {
                    /* Refund webhook error */
                    if (refundBtn) {
                        refundBtn.disabled = false;
                        refundBtn.innerHTML = '<span>Error - Try Again</span>';
                    }
                    self.showSystemError();
                });
            },

            submitFromThankYou: function (btn) {
                var self = this;

                // ✅ Prevenir doble submit
                if (this._isSubmittingThankYou) return;
                this._isSubmittingThankYou = true;

                // ✅ Cancelar auto-redirect inmediatamente
                if (this.redirectTimeout) {
                    clearTimeout(this.redirectTimeout);
                    this.redirectTimeout = null;
                }
                if (this.countdownInterval) {
                    clearInterval(this.countdownInterval);
                    this.countdownInterval = null;
                }
                this.autoRedirectActive = false;

                // Feedback visual
                if (btn) {
                    btn.classList.add('qz-btn-processing');
                    btn.disabled = true;
                }

                // Cambiar texto del countdown
                var countdownEl = document.getElementById('qz-countdown');
                if (countdownEl && countdownEl.parentElement) {
                    countdownEl.parentElement.innerHTML = '<span style="color: #12315E; font-weight: 700;">Redirecting...</span>';
                }

                // Enviar y redireccionar
                this.submitGeneralIntake(function () {
                    self.proceedToProductForms();
                }).catch(function (err) {
                    self._isSubmittingThankYou = false;
                    if (btn) {
                        btn.classList.remove('qz-btn-processing');
                        btn.disabled = false;
                        btn.innerHTML = '<span>Continue to Product Forms →</span>';
                    }
                    alert('Error submitting form: ' + err.message);
                });
            },

            startAutoRedirect: function () {
                var self = this;
                var alreadyCompletedEl = document.getElementById('step-already-completed');
                var isAlreadyCompletedStep = alreadyCompletedEl && alreadyCompletedEl.classList.contains('active-step');
                var countdownId = isAlreadyCompletedStep ? 'qz-completed-countdown' : 'qz-countdown';
                var countdownEl = document.getElementById(countdownId);
                var seconds = countdownEl ? parseInt(countdownEl.innerText) || 30 : 30;

                // Limpieza de timers previos
                if (this.countdownInterval) {
                    clearInterval(this.countdownInterval);
                    this.countdownInterval = null;
                }
                if (this.redirectTimeout) {
                    clearTimeout(this.redirectTimeout);
                    this.redirectTimeout = null;
                }

                this.autoRedirectActive = true;
                if (countdownEl) countdownEl.innerText = seconds;

                // Countdown visual
                this.countdownInterval = setInterval(function () {
                    var stepEl = isAlreadyCompletedStep ? 
                        document.getElementById('step-already-completed') :
                        document.getElementById('step-thank-you');
                    var stillOnStep = stepEl && stepEl.classList.contains('active-step');

                    if (!stillOnStep) {
                        clearInterval(self.countdownInterval);
                        self.countdownInterval = null;
                        return;
                    }
                    seconds--;
                    if (countdownEl) countdownEl.innerText = seconds;
                    if (seconds <= 0) {
                        clearInterval(self.countdownInterval);
                        self.countdownInterval = null;
                    }
                }, 1000);

                // ✅ REDIRECCIÓN CON SUBMIT: Mostrar processing overlay, hacer submit, luego redirigir
                this.redirectTimeout = setTimeout(function () {
                    var stepEl = isAlreadyCompletedStep ? 
                        document.getElementById('step-already-completed') :
                        document.getElementById('step-thank-you');
                    var stillOnStep = stepEl && stepEl.classList.contains('active-step');

                    if (!stillOnStep) {
                        self.autoRedirectActive = false;
                        return;
                    }

                    if (isAlreadyCompletedStep) {
                        // Direct redirect for already completed
                        self.proceedToProductForms();
                    } else {
                        // Regular flow: submit then redirect
                        var overlay = document.getElementById('qz-processing-overlay');
                        if (overlay) {
                            overlay.querySelector('.qz-loader-text').innerText = "Submitting Medical Data";
                            overlay.querySelector('.qz-sub').innerText = "Please wait while we secure your information...";
                            overlay.classList.add('is-active');
                        }

                        self.submitGeneralIntake(function () {
                            self.proceedToProductForms();
                        }).catch(function (err) {
                            if (overlay) overlay.classList.remove('is-active');
                            self.autoRedirectActive = false;
                            alert('Error submitting form. Please click "Continue to Product Forms" to retry.');
                        });
                    }
                }, seconds * 1000);
            },

            setupUIHelpers: function () {
                var self = this;
                document.querySelectorAll('.qz-step').forEach(function (step) {
                    var stacked = step.querySelector('.qz-actions-stacked');
                    if (stacked) {
                        stacked.classList.add('qz-sticky-footer');
                        return;
                    }
                    var btn = step.querySelector('.qz-btn');
                    if (btn && btn.parentElement === step) {
                        var wrapper = document.createElement('div');
                        wrapper.className = 'qz-sticky-footer';
                        step.insertBefore(wrapper, btn);
                        wrapper.appendChild(btn);
                    }
                });
                Object.freeze(this.KNOCKOUT_RULES);
                Object.freeze(this.AGREEMENT_RULES);
                Object.freeze(this.EXEMPT_VARIANT_IDS);
            },

            applySecurityShield: function (stepElement) {
                var self = this;

                // DEFENSA: Verificar que stepElement sea válido
                if (stepElement && !(stepElement instanceof Element)) {
                    /* applySecurityShield: elemento inválido */
                    stepElement = null;  // Fallback a document
                }

                var container = stepElement || document;
                var inputs = container.querySelectorAll('input, textarea, select');

                inputs.forEach(function (input) {
                    // DEFENSA: Verificar que input existe y es válido
                    if (!input || !input.nodeType) {
                        /* Input inválido */
                        return;  // Skip este input
                    }

                    // DEFENSA: No añadir listeners duplicados
                    if (input.dataset.securityShieldApplied) {
                        return;
                    }
                    input.dataset.securityShieldApplied = 'true';

                    try {
                        input.addEventListener('input', function () {
                            if (!this.parentNode) return;  // Verificar aún en DOM
                            var value = this.value;
                            value = value.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
                                .replace(/javascript:/gi, '');
                            this.value = value;
                        });

                        input.addEventListener('paste', function (e) {
                            if (!this.parentNode) return;
                            e.preventDefault();
                            var clipboardData = e.clipboardData || window.clipboardData;
                            var pastedData = clipboardData.getData('Text');
                            pastedData = pastedData.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
                                .replace(/javascript:/gi, '');
                            this.value = pastedData;
                        });

                        input.addEventListener('drop', function (e) {
                            if (!this.parentNode) return;
                            e.preventDefault();
                            var text = e.dataTransfer.getData("text/plain");
                            text = text.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
                                .replace(/javascript:/gi, '');
                            this.value = text;
                        });

                        input.setAttribute('autocomplete', 'off');
                        input.setAttribute('data-lpignore', 'true');
                        input.setAttribute('autocapitalize', 'none');

                    } catch (err) {
                        /* Error aplicando security shield */
                    }
                });
            },

            sanitizeInput: function (str) {
                if (typeof str !== 'string') return str;
                return str.replace(/[&<>'"]/g, function (tag) {
                    var charsToReplace = { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' };
                    return charsToReplace[tag] || tag;
                });
            },

            hideLoader: function () {
                if (this.DOM.loader) this.DOM.loader.style.setProperty('display', 'none', 'important');
            },

            // Utilidad debounce para inputs
            debounce: function(key, fn, delay) {
                if (this.debounceTimers[key]) {
                    clearTimeout(this.debounceTimers[key]);
                }
                this.debounceTimers[key] = setTimeout(fn.bind(this), delay);
            },

            fetchRealOrderData: function (orderId, retries) {
                retries = retries || 2;
                var self = this;
                return new Promise(function (resolve, reject) {
                    function doFetch(url, n, onFail) {
                        fetch(url, {
                            method: 'POST',
                            mode: 'cors',
                            credentials: 'omit',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            body: JSON.stringify({ order_id: orderId, ts: Date.now() })
                        })
                            .then(function (response) {
                                if (!response.ok) throw new Error("HTTP " + response.status);
                                return response.json();
                            })
                            .then(resolve)
                            .catch(function (error) {
                                if (n <= 0) {
                                    onFail(error);
                                } else {
                                    setTimeout(function () { doFetch(url, n - 1, onFail); }, 1000);
                                }
                            });
                    }
                    
                    doFetch(CONFIG.WEBHOOK_GET_DATA, retries, function(primaryError) {
                        if (CONFIG.WEBHOOK_GET_DATA_FALLBACK) {
                            doFetch(CONFIG.WEBHOOK_GET_DATA_FALLBACK, retries, function(fallbackError) {
                                reject(fallbackError);
                            });
                        } else {
                            reject(primaryError);
                        }
                    });
                });
            },

            saveToSession: function () {
                try {
                    var rawData = this.userData.answers;
                    var cleanAnswers = {};

                    for (var key in rawData) {
                        if (rawData.hasOwnProperty(key)) {
                            var val = rawData[key];
                            if (val === null || val === undefined || val === "" || (Array.isArray(val) && val.length === 0)) {
                                continue;
                            }
                            if (key.indexOf('_base64') !== -1 || (typeof val === 'string' && val.length > 5120)) {
                                continue;
                            }
                            cleanAnswers[key] = val;
                        }
                    }

                    var payload = JSON.stringify({
                        answers: cleanAnswers,
                        stepIndex: this.stepIndex,
                        timestamp: Date.now()
                    });
                    sessionStorage.setItem('levers_form_draft', payload);
                } catch (e) {
                    /* SessionStorage saturation */
                }
            },

            processOrderContext: function (data) {
                var orderData = Array.isArray(data) ? data[0] : data;
                if (!orderData) {
                    /* Estructura de datos inválida */
                    return;
                }

                // DEBUG: Ver qué datos llegan del webhook
                /* Webhook data received */

                // Datos básicos del cliente
                // Si estamos en modo update (bypassIntakeCompleted), mantener isReturning = false
                // para mostrar todos los pasos de actualización
                if (!this.bypassIntakeCompleted) {
                    this.isReturning = (orderData.returning_patient === true);
                    this.userData.isReturning = this.isReturning;
                }

                // ✅ NUEVO: Detectar si la orden fue refundeada
                // Soporta: refund: true, refund: "true", isRefunded: true, status: "refunded"
                var refundValue = orderData.refund ?? orderData.isRefunded ?? orderData.is_refunded ?? orderData.status;
                this.isRefunded = (
                    refundValue === true || 
                    refundValue === 1 || 
                    refundValue === "true" || 
                    refundValue === "yes" ||
                    refundValue === "refunded" ||
                    refundValue === "cancelled"
                );
                this.userData.isRefunded = this.isRefunded;
                
                if (this.isRefunded) {
                    /* Order detected as refunded/cancelled */
                }

                this.productsList = orderData.products || null;

                this.userData.customer = {
                    first_name: orderData.first_name || "",
                    last_name: orderData.last_name || "",
                    phone: orderData.phone || "",
                    email: orderData.email || ""
                };

                // Store original order contact data for mismatch detection
                this._originalCustomer = {
                    email: (orderData.email || "").toLowerCase().trim(),
                    phone: (orderData.phone || "").replace(/\D/g, ""),
                    display_email: orderData.email || "",
                    display_phone: orderData.phone || ""
                };

                // Pre-llenar campos si existen
                if (this.userData.customer.first_name) {
                    var f = document.getElementById('qz-fname');
                    if (f) f.value = this.userData.customer.first_name;
                    var l = document.getElementById('qz-lname');
                    if (l) l.value = this.userData.customer.last_name;
                    var e = document.getElementById('qz-email');
                    if (e) e.value = this.userData.customer.email;
                    var p = document.getElementById('qz-phone');
                    if (p) p.value = this.userData.customer.phone;
                }

                // ✅ NUEVO: Procesar variantes GLP desde string separado por comas
                this.isGLP = orderData.isGLP === true;
                this.formToRedirect = orderData.form_to_redirect || null;
                this.intakeCompleted = (orderData.intake_completed === true);

                // ✅ NUEVO: Parsear glpVariants string a array de objetos con threshold
                this.glpVariants = [];
                if (this.isGLP && orderData.glpVariant) {
                    var variantNames = orderData.glpVariant.split(',').map(function (v) {
                        return v.trim();
                    });

                    var self = this;
                    variantNames.forEach(function (variantName) {
                        var threshold = GLP_VARIANT_THRESHOLDS[variantName];
                        if (threshold) {
                            self.glpVariants.push({
                                name: variantName,
                                threshold: parseInt(threshold),
                                status: null // se calculará después
                            });
                        } else {
                            /* Variante GLP no encontrada en mapa */
                            // Default a 25 si no está en el mapa
                            self.glpVariants.push({
                                name: variantName,
                                threshold: 25,
                                status: null
                            });
                        }
                    });
                }

                // ✅ NUEVO: Procesar product_ids para validación por estado
                this.productIds = [];
                if (orderData.product_ids) {
                    // product_ids puede ser string separado por comas o array
                    if (typeof orderData.product_ids === 'string') {
                        this.productIds = orderData.product_ids.split(',').map(function (pid) {
                            return pid.trim();
                        }).filter(function (pid) {
                            return pid.length > 0;
                        });
                    } else if (Array.isArray(orderData.product_ids)) {
                        this.productIds = orderData.product_ids.map(function (pid) {
                            return String(pid).trim();
                        });
                    }
                    /* Product IDs cargados */
                }

                // ✅ NUEVO: Agregar estados del PRODUCT_REGISTRY a ALLOWED_STATES
                // Esto permite que los estados específicos de productos sean válidos
                for (var productId in PRODUCT_REGISTRY) {
                    if (PRODUCT_REGISTRY.hasOwnProperty(productId)) {
                        var productInfo = PRODUCT_REGISTRY[productId];
                        if (productInfo.allowedStates && Array.isArray(productInfo.allowedStates)) {
                            productInfo.allowedStates.forEach(function (state) {
                                if (!CONFIG.ALLOWED_STATES.includes(state)) {
                                    CONFIG.ALLOWED_STATES.push(state);
                                }
                            });
                        }
                    }
                }

                this.userData.orderContext = {
                    orderId: orderData.id || "from_webhook"
                };
            },

            renderProducts: function (productsString) {
                if (!productsString || typeof productsString !== 'string') {
                    return;
                }

                var productsCard = document.getElementById('qz-products-card');
                var productsList = document.getElementById('qz-products-list');

                if (!productsCard || !productsList) {
                    /* Product DOM elements not found */
                    return;
                }

                // Parsear string separado por comas
                var products = productsString
                    .split(',')
                    .map(function (p) { return p.trim(); })
                    .filter(function (p) { return p.length > 0; });

                if (products.length === 0) {
                    productsCard.style.display = 'none';
                    return;
                }

                // Limpiar y generar lista
                productsList.innerHTML = '';
                products.forEach(function (productName) {
                    var li = document.createElement('li');
                    li.innerHTML =
                        '<span class="qz-product-bullet"></span>' +
                        '<span class="qz-product-name">' + this.escapeHtml(productName) + '</span>';
                    productsList.appendChild(li);
                }.bind(this));

                // Mostrar con animación
                productsCard.style.display = 'block';
                // Forzar reflow para animación
                void productsCard.offsetWidth;
                productsCard.classList.add('is-visible');
            },

            escapeHtml: function (text) {
                var div = document.createElement('div');
                div.textContent = text;
                return div.innerHTML;
            },

            evaluateGLPVariantsBMI: function (bmi) {
                if (!this.glpVariants || this.glpVariants.length === 0) return;

                var self = this;
                var hasFail = false;
                var hasPass = false;

                this.glpVariants.forEach(function (variant) {
                    var threshold = 25; // Default

                    // Match variant name with thresholds
                    for (var key in GLP_VARIANT_THRESHOLDS) {
                        if (variant.name.toLowerCase().includes(key.toLowerCase())) {
                            threshold = GLP_VARIANT_THRESHOLDS[key];
                            break;
                        }
                    }

                    variant.threshold = threshold;
                    variant.bmi = bmi;
                    if (bmi >= threshold) {
                        variant.status = 'eligible';
                        hasPass = true;
                    } else {
                        variant.status = 'warning';
                        hasFail = true;
                    }
                });

                if (hasPass && hasFail) {
                    this.userData.bmiStatus = 'mixed';
                } else if (hasPass) {
                    this.userData.bmiStatus = 'eligible';
                } else {
                    this.userData.bmiStatus = 'warning';
                }
            },

            calculateRoute: function () {
                // ✅ PRIORIDAD 1: Si la orden fue refundeada, mostrar solo el paso de refund
                if (this.isRefunded) {
                    this.currentRoute = ['step-order-refunded'];
                    return;
                }

                // ✅ BYPASS: Si el usuario quiere actualizar su información, ignorar intakeCompleted
                if (this.intakeCompleted && !this.bypassIntakeCompleted) {
                    if (this.formToRedirect) {
                        this.currentRoute = ['step-already-completed'];
                    } else {
                        this.currentRoute = ['step-all-set'];
                    }
                    return;
                }

                var route = ['step-welcome', 'step-verify-both-changed'];
                var self = this;
                var identityChoice = this.userData.answers['contact_identity_choice'];
                
                // Si aún no ha respondido la pregunta de identidad, mostrar solo welcome + verify
                if (!identityChoice) {
                    this.currentRoute = route;
                    return;
                }
                
                // Returning patient que elige "for myself" → flujo corto
                if (this.isReturning && identityChoice === 'for-me') {
                    if (this.formToRedirect) {
                        route.push('step-already-completed');
                    } else {
                        route.push('step-all-set');
                    }
                    this.currentRoute = route;
                    return;
                }
                
                // Returning patient que elige "for someone else" → aviso
                if (this.isReturning && identityChoice === 'for-someone-else') {
                    route.push('step-returning-proxy-notice');
                }
                
                // Todos los demás (nuevos o returning-for-someone-else) → flujo completo
                route.push('step-contact');

                if (identityChoice === 'for-someone-else') {
                    route.push('step-contact-proxy-agreement');
                }

                // Función genérica para verificar condiciones en respuestas
                var checkCondition = function (key, conditionFn) {
                    var ans = self.userData.answers[key];
                    if (!ans) return false;
                    if (Array.isArray(ans)) {
                        return ans.some(function (a) { return conditionFn(a, key); });
                    }
                    return conditionFn(ans, key);
                };
                
                // Wrapper para check 'Other'
                var checkOther = function (key) {
                    return checkCondition(key, function(a) { return a === 'Other'; });
                };

                // Wrapper para check agreement rules
                var checkAgreement = function (key) {
                    var rules = self.AGREEMENT_RULES[key];
                    if (!rules) return false;
                    return checkCondition(key, function(a) { return rules[a]; });
                };

                // BMI eligibility now handled via evaluateGLPVariantsBMI called during calcBMI

                // Variable local: solo se considera "returning" si eligió "for me"
                var isReturningFlow = this.isReturning && identityChoice === 'for-me';

                // step-metrics para TODOS (returning y no returning)
                route.push('step-metrics');

                // Validaciones BMI solo para GLP
                if (this.isGLP) {
                    var bmiStatus = this.userData.bmiStatus;
                    if (bmiStatus === 'eligible') {
                        route.push('step-bmi-success');
                    } else if (bmiStatus === 'warning') {
                        route.push('step-bmi-warning');
                    } else if (bmiStatus === 'mixed') {
                        route.push('step-bmi-success');
                        route.push('step-bmi-warning');
                    }
                }

                // Solo no returning: state, restrictions, dob
                if (!isReturningFlow) {
                    route.push('step-state');

                    if (this.restrictedProducts && this.restrictedProducts.length > 0 && 
                        this.allowedProducts && this.allowedProducts.length > 0) {
                        route.push('step-product-state-restriction');
                    }

                    route.push('step-dob');
                }

                if (!isReturningFlow) {
                    route.push('step-sex');
                }

                if (this.userData.answers['sex'] === 'Female') {
                    route.push('step-female');
                    if (checkAgreement('Pregnancy_And_Hormonal_Status') || checkAgreement('Menopause_Stage')) {
                        route.push('step-dynamic-agreement');
                    }
                }

                route.push('step-activity', 'step-diet');

                if (!isReturningFlow) {
                    route.push('step-History_of_Cancer');
                    // Si seleccionó algo que NO es "No", pedir detalles del cáncer
                    var cancerAns = this.userData.answers['History_of_Cancer'];
                    var requiresCancerDetails = cancerAns && cancerAns !== 'No';
                    if (requiresCancerDetails) route.push('step-dynamic-other');
                    if (checkAgreement('History_of_Cancer')) route.push('step-dynamic-agreement');

                    route.push('step-Diabetes_Insulin_Resistance_History');
                    if (checkOther('Diabetes_Insulin_Resistance_History')) route.push('step-dynamic-other');
                    if (checkAgreement('Diabetes_Insulin_Resistance_History')) route.push('step-dynamic-agreement');

                    route.push('step-Cardiovascular_History');
                    if (checkOther('Cardiovascular_History')) route.push('step-dynamic-other');
                    if (checkAgreement('Cardiovascular_History')) route.push('step-dynamic-agreement');

                    route.push('step-Thyroid_Conditions');
                    if (checkOther('Thyroid_Conditions')) route.push('step-dynamic-other');
                    if (checkAgreement('Thyroid_Conditions')) route.push('step-dynamic-agreement');

                    route.push('step-autoimmune');
                    if (checkOther('autoimmune')) route.push('step-dynamic-other');
                    if (checkAgreement('autoimmune')) route.push('step-dynamic-agreement');

                    route.push('step-mental');
                    if (checkOther('mental')) route.push('step-dynamic-other');
                    if (checkAgreement('mental')) route.push('step-dynamic-agreement');

                    route.push('step-neuro');
                    if (checkOther('neuro')) route.push('step-dynamic-other');
                    if (checkAgreement('neuro')) route.push('step-dynamic-agreement');

                    route.push('step-musculo');
                    if (checkOther('musculo')) route.push('step-dynamic-other');
                    if (checkAgreement('musculo')) route.push('step-dynamic-agreement');

                    route.push('step-digestive');
                    if (checkOther('digestive')) route.push('step-dynamic-other');
                    if (checkAgreement('digestive')) route.push('step-dynamic-agreement');

                    route.push('step-blood', 'step-cholesterol', 'step-lifestyle-factors', 'step-family');

                    var famAns = self.userData.answers['family'] || [];
                    var hasRealFamilyCondition = Array.isArray(famAns) && famAns.some(function (f) { return f !== 'None'; });
                    if (hasRealFamilyCondition) route.push('step-dynamic-other');
                    if (checkAgreement('family')) route.push('step-dynamic-agreement');

                    route.push('step-surgeries', 'step-medications');

                    route.push('step-med-conditions');
                    var medAns = self.userData.answers['med-conditions'];
                    var requiresMedDetails = Array.isArray(medAns) ? medAns.includes('Yes') : medAns === 'Yes';
                    if (requiresMedDetails) route.push('step-dynamic-other');
                    if (checkAgreement('med-conditions')) route.push('step-dynamic-agreement');

                    route.push('step-id-upload');
                    route.push('step-marketing-source');
                    var marketingSource = this.userData.answers['marketing_source'];
                    var sourcesRequiringDetails = [
                        'Referred by a friend or family',
                        'Referred by another patient',
                        'Doctor or healthcare provider',
                        'Weight loss community group',
                        'Other'
                    ];

                    if (sourcesRequiringDetails.includes(marketingSource)) {
                        route.push('step-marketing-details');
                    }
                }

                // ✅ NUEVO: Siempre terminar con thank you si hay redirección configurada
                if (this.formToRedirect) {
                    route.push('step-thank-you');
                }

                this.currentRoute = route;
            },

            next: function () {
                // ✅ Limpiar redirects pendientes SIEMPRE al cambiar de paso
                if (this.redirectTimeout) {
                    clearTimeout(this.redirectTimeout);
                    this.redirectTimeout = null;
                }
                if (this.countdownInterval) {
                    clearInterval(this.countdownInterval);
                    this.countdownInterval = null;
                }
                this.autoRedirectActive = false;

                this.calculateRoute();
                
                var nextIndex = this.stepIndex + 1;

                if (nextIndex >= this.currentRoute.length) {
                    if (this.formToRedirect) {
                        /* At thank you step */
                    } else {
                        window.location.href = "https://levers.health/pages/thank-you";
                    }
                    return;
                }

                this.stepIndex = nextIndex;
                this.saveToSession();
                this.updateUI();
            },

            back: function () {
                // ✅ Limpiar redirects pendientes SIEMPRE al volver atrás
                if (this.redirectTimeout) {
                    clearTimeout(this.redirectTimeout);
                    this.redirectTimeout = null;
                }
                if (this.countdownInterval) {
                    clearInterval(this.countdownInterval);
                    this.countdownInterval = null;
                }
                this.autoRedirectActive = false;

                if (this.stepIndex > 0) {
                    this.stepIndex--;
                    this.saveToSession();
                    this.updateUI();
                }
            },

            proceedToProductForms: function () {
                var self = this;
                
                // Cancelar countdown
                if (this.redirectTimeout) clearTimeout(this.redirectTimeout);
                if (this.countdownInterval) clearInterval(this.countdownInterval);

                // Validar que tenemos URL
                if (!this.formToRedirect) {
                    /* No form_to_redirect configured */
                    window.location.href = "https://levers.health/pages/thank-you";
                    return;
                }

                // Construir URL final: form_to_redirect + ?order_id=XXX
                var orderId = this.urlOrderId || (this.userData && this.userData.orderContext && this.userData.orderContext.orderId) || "unknown";
                var separator = this.formToRedirect.indexOf('?') !== -1 ? '&' : '?';
                var finalUrl = this.formToRedirect + separator + 'order_id=' + encodeURIComponent(orderId);
                
                /* Redirecting to product form */

                // Mostrar loader
                var overlay = document.getElementById('qz-processing-overlay');
                if (overlay) {
                    var loaderText = overlay.querySelector('.qz-loader-text');
                    var loaderSub = overlay.querySelector('.qz-sub');
                    if (loaderText) loaderText.innerText = "Redirecting to Product Form";
                    if (loaderSub) loaderSub.innerText = "Please wait...";
                    overlay.classList.add('is-active');
                }

                // Redirigir inmediatamente sin setTimeout para evitar problemas
                window.location.href = finalUrl;
            },

            updateInformation: function () {
                // HIPAA-COMPLIANT: Usar URL param en lugar de sessionStorage
                // Redirigir a la misma página con ?update=true
                var url = new URL(window.location.href);
                url.searchParams.set('update', 'true');
                window.location.href = url.toString();
            },

            saveOtherDetails: function () {
                var textarea = document.getElementById('qz-other-textarea');
                if (textarea) {
                    var textareaValue = textarea.value;
                    var parentStepId = this.currentRoute[this.stepIndex - 1];
                    var parentKey = parentStepId.replace('step-', '');
                    this.userData.answers[parentKey + '_details'] = this.sanitizeInput(textareaValue);
                }
                this.next();
            },

            updateUI: function () {
                var self = this;
                // Usar DOM cacheado en lugar de querySelectorAll
                this.DOM.steps.forEach(function (s) {
                    s.classList.remove('active-step');
                });

                // Resetear botones solo en el paso actual (más eficiente)
                var currentStepEl = document.getElementById(this.currentRoute[this.stepIndex]);
                if (currentStepEl) {
                    var buttons = currentStepEl.querySelectorAll('.qz-btn');
                    buttons.forEach(function (btn) {
                        btn.classList.remove('qz-btn-processing');
                        btn.disabled = false;
                        btn.style.opacity = '1';
                        btn.style.cursor = 'pointer';
                        btn.style.pointerEvents = 'auto';
                    });
                }
                
                // ✅ Resetear botón back específicamente (puede estar fuera del step)
                var backBtn = document.getElementById('qz-back-btn');
                if (backBtn) {
                    backBtn.classList.remove('qz-btn-processing');
                    backBtn.disabled = false;
                }

                var currentStepId = this.currentRoute[this.stepIndex];

                if (currentStepId === 'step-welcome') {
                    var titleEl = document.getElementById('qz-welcome-header');
                    var subEl = document.getElementById('qz-welcome-sub');

                    // Obtener referencia al botón de actualizar
                    var updateBtn = document.getElementById('qz-update-info-btn');
                    
                    // Lógica: Mostrar botón SOLO si es returning patient Y no está en modo update
                    var isExplicitlyReturning = this.isReturning === true;
                    var isInUpdateMode = this.bypassIntakeCompleted === true;
                    var showUpdateButton = isExplicitlyReturning && !isInUpdateMode;
                    
                    if (this.isReturning && !this.bypassIntakeCompleted) {
                        // Returning patient normal - muestra mensaje de welcome back y botón
                        if (titleEl) titleEl.innerHTML = 'Welcome Back to <span class="qz-gradient-text">Levers! 🌟</span>';
                        if (subEl) subEl.innerText = "Welcome back! To be approved for your new treatment, please submit this medical history form.";
                    } else if (this.bypassIntakeCompleted) {
                        // Modo actualización - muestra mensaje de update, sin botón
                        if (titleEl) titleEl.innerHTML = 'Update Your <span class="qz-gradient-text">Information 🌟</span>';
                        if (subEl) subEl.innerText = "Please review and update your information to ensure we have your correct details on file.";
                    } else {
                        // Paciente nuevo - mensaje normal, sin botón
                        if (titleEl) titleEl.innerHTML = 'Welcome to <span class="qz-gradient-text">Levers! 🌟</span>';
                        if (subEl) subEl.innerText = "To be approved for your new treatment, please submit this medical history form.";
                    }
                    
                    // Mostrar u ocultar botón de actualizar información - NUCLEAR
                    if (updateBtn) {
                        // Primero remover todo (estado por defecto: OCULTO)
                        updateBtn.classList.remove('is-visible');
                        updateBtn.removeAttribute('data-show');
                        
                        // Solo mostrar si EXPLÍCITAMENTE es returning patient Y no está en modo update
                        if (showUpdateButton === true) {
                            updateBtn.classList.add('is-visible');
                            updateBtn.setAttribute('data-show', 'true');
                        }
                    }

                    if (this.productsList && typeof this.productsList === 'string') {
                        this.renderProducts(this.productsList);
                    } else {
                        /* productsList not available */
                        // Ocultar el card si no hay productos
                        var productsCard = document.getElementById('qz-products-card');
                        if (productsCard) productsCard.style.display = 'none';
                    }
                }

                var currElement = document.getElementById(currentStepId);

                // CONTACT VERIFICATION - render before/after comparison
                if (currentStepId === 'step-verify-contact' && this._contactMismatch) {
                    var container = document.getElementById('qz-verify-single-content');
                    if (container) {
                        var html = '';
                        var m = this._contactMismatch;
                        
                        if (m.emailChanged) {
                            html += `
                                <div class="qz-diff-row">
                                    <span class="qz-diff-label">Email Address</span>
                                    <div class="qz-diff-values">
                                        <div class="qz-diff-item">
                                            <span class="qz-diff-chip is-old">Current</span>
                                            <span class="qz-diff-content">${this.escapeHtml(this._originalCustomer.display_email)}</span>
                                        </div>
                                        <div class="qz-diff-arrow"></div>
                                        <div class="qz-diff-item is-changed">
                                            <span class="qz-diff-chip is-new">New</span>
                                            <span class="qz-diff-content">${this.escapeHtml(this.userData.customer.email)}</span>
                                        </div>
                                    </div>
                                </div>`;
                        }
                        
                        if (m.phoneChanged) {
                            html += `
                                <div class="qz-diff-row">
                                    <span class="qz-diff-label">Phone Number</span>
                                    <div class="qz-diff-values">
                                        <div class="qz-diff-item">
                                            <span class="qz-diff-chip is-old">Current</span>
                                            <span class="qz-diff-content">${this.formatPhoneDisplay(this._originalCustomer.display_phone)}</span>
                                        </div>
                                        <div class="qz-diff-arrow"></div>
                                        <div class="qz-diff-item is-changed">
                                            <span class="qz-diff-chip is-new">New</span>
                                            <span class="qz-diff-content">${this.formatPhoneDisplay(this.userData.customer.phone)}</span>
                                        </div>
                                    </div>
                                </div>`;
                        }
                        container.innerHTML = html;
                    }
                }

                // CONFIRM UPDATE - populate new email/phone values
                if (currentStepId === 'step-confirm-update') {
                    var emailEl = document.getElementById('qz-confirm-new-email');
                    var phoneEl = document.getElementById('qz-confirm-new-phone');
                    if (emailEl) emailEl.innerText = this.userData.customer.email || '--';
                    if (phoneEl) phoneEl.innerText = this.formatPhoneDisplay(this.userData.customer.display_phone || this.userData.customer.phone) || '--';
                }

                // BMI SUCCESS (Premium Redesign)
                if (currentStepId === 'step-bmi-success') {
                    const bmiData = this.userData.answers['bmi_metrics'] || {};
                    const bmi = bmiData.bmi || "--";
                    const valEl = document.getElementById('qz-bmi-val-success');
                    if (valEl) valEl.innerText = bmi;

                    const container = document.getElementById('qz-success-variants-list');
                    if (container && this.glpVariants) {
                        container.innerHTML = '';
                        this.glpVariants.filter(function (v) { 
                            return v.status === 'eligible'; 
                        }).forEach(function (v) {
                            var row = document.createElement('div');
                            row.className = 'qz-variant-row-premium';
                            row.innerHTML = `
                                <div class="qz-variant-info">
                                    <span class="qz-variant-name-premium">${v.name}</span>
                                    <span class="qz-variant-threshold-premium">Requirement: ${v.threshold}+ BMI ✓</span>
                                </div>
                                <span class="qz-variant-badge is-eligible">Approved</span>
                            `;
                            container.appendChild(row);
                        });
                    }
                }

                // BMI WARNING (Premium Redesign)
                if (currentStepId === 'step-bmi-warning') {
                    const bmiData = this.userData.answers['bmi_metrics'] || {};
                    const bmi = bmiData.bmi || "--";
                    const valEl = document.getElementById('qz-bmi-val-fail');
                    if (valEl) valEl.innerText = bmi;

                    const container = document.getElementById('qz-warning-variants-list');
                    if (container && this.glpVariants) {
                        container.innerHTML = '';
                        this.glpVariants.filter(function (v) { 
                            return v.status === 'warning'; 
                        }).forEach(function (v) {
                            var row = document.createElement('div');
                            row.className = 'qz-variant-row-premium';
                            row.innerHTML = `
                                <div class="qz-variant-info">
                                    <span class="qz-variant-name-premium">${v.name}</span>
                                    <span class="qz-variant-threshold-premium">Requires: ${v.threshold}+ BMI</span>
                                </div>
                                <span class="qz-variant-badge is-warning">Manual Review</span>
                            `;
                            container.appendChild(row);
                        });
                    }
                }

                // PRODUCT STATE RESTRICTION - Render restricted products
                if (currentStepId === 'step-product-state-restriction') {
                    this.renderRestrictedProducts();
                }

                if (currentStepId === 'step-dynamic-other') {
                    this.applySecurityShield(document.getElementById(currentStepId));
                    var parentStepId = this.currentRoute[this.stepIndex - 1];
                    var parentKey = parentStepId.replace('step-', '');

                    var config = this.OTHER_MAP[parentKey] || { title: "Details", sub: "Please specify." };
                    var titleText = config.title !== undefined ? config.title : "Details";
                    var subText = config.sub !== undefined ? config.sub : "Please specify.";

                    var answerRaw = this.userData.answers[parentKey];
                    var selectedStr = "";

                    // Caso especial para Cancer - valor es string simple, no array
                    if (parentKey === 'History_of_Cancer' && answerRaw) {
                        selectedStr = answerRaw;
                    } else if (Array.isArray(answerRaw)) {
                        selectedStr = answerRaw.join(', ');
                    } else {
                        selectedStr = answerRaw || "";
                    }

                    selectedStr = selectedStr.toLowerCase();

                    if (titleText.indexOf('__selected__') !== -1) {
                        titleText = titleText.replace('__selected__', selectedStr);
                    }
                    if (subText.indexOf('__selected__') !== -1) {
                        subText = subText.replace('__selected__', selectedStr);
                    }

                    var titleEl = document.getElementById('dynamic-other-title');
                    var subEl = document.getElementById('dynamic-other-sub');
                    var textarea = document.getElementById('dynamic-other-textarea');

                    if (titleEl) {
                        titleEl.innerHTML = titleText;
                        titleEl.removeAttribute('style');
                        if (config.styles && config.styles.title) titleEl.style.cssText = config.styles.title;
                    }

                    if (subEl) {
                        if (subText === "") {
                            subEl.style.setProperty('display', 'none', 'important');
                            subEl.innerHTML = "";
                        } else {
                            subEl.style.setProperty('display', 'block', 'important');
                            subEl.innerHTML = subText;
                            subEl.removeAttribute('style');
                            if (config.styles && config.styles.sub) subEl.style.cssText = config.styles.sub;
                        }
                    }

                    if (textarea) {
                        textarea.setAttribute('data-parent', parentKey);
                        textarea.setAttribute('data-key', parentKey + '_details');
                        textarea.value = this.userData.answers[parentKey + '_details'] || '';
                        this.clearError('dynamic-other-textarea');
                    }
                }

                if (currentStepId === 'step-dynamic-agreement') {
                    this.applySecurityShield(document.getElementById(currentStepId));
                    var parentStepIdAg = this.currentRoute[this.stepIndex - 1];
                    if (parentStepIdAg === 'step-dynamic-other') {
                        parentStepIdAg = this.currentRoute[this.stepIndex - 2];
                    }
                    var parentKeyAg = parentStepIdAg.replace('step-', '');

                    if (parentKeyAg === 'female') {
                        var pregAns = this.userData.answers['Pregnancy_And_Hormonal_Status'];
                        var menoAns = this.userData.answers['Menopause_Stage'];
                        var pregRules = this.AGREEMENT_RULES['Pregnancy_And_Hormonal_Status'];
                        var menoRules = this.AGREEMENT_RULES['Menopause_Stage'];
                        if (pregRules && pregRules[pregAns]) {
                            parentKeyAg = 'Pregnancy_And_Hormonal_Status';
                        } else if (menoRules && menoRules[menoAns]) {
                            parentKeyAg = 'Menopause_Stage';
                        }
                    }

                    var rules = this.AGREEMENT_RULES[parentKeyAg];

                    if (rules) {
                        var selectedAnswers = this.userData.answers[parentKeyAg];
                        var activeRule = null;
                        var triggerValue = "";

                        if (rules) {
                            if (Array.isArray(selectedAnswers)) {
                                triggerValue = selectedAnswers.find(function (a) { return rules[a]; });
                                if (triggerValue) activeRule = rules[triggerValue];
                            } else {
                                triggerValue = selectedAnswers;
                                if (rules[triggerValue]) activeRule = rules[triggerValue];
                            }
                        }

                        if (activeRule) {
                            var titleElAg = document.getElementById('qz-agree-title');
                            var subElAg = document.getElementById('qz-agree-sub');
                            var textWrapperAg = document.getElementById('qz-agree-text-wrapper');
                            var textElAg = document.getElementById('qz-agree-text');

                            titleElAg.className = 'qz-title qz-agreement-title';
                            titleElAg.removeAttribute('style');

                            subElAg.className = 'qz-sub qz-agreement-sub';
                            subElAg.removeAttribute('style');

                            if (textWrapperAg) {
                                textWrapperAg.className = 'qz-agreement-details-box';
                                textWrapperAg.removeAttribute('style');
                            }

                            titleElAg.innerHTML = activeRule.title;
                            subElAg.innerHTML = activeRule.sub;

                            if (activeRule.text && activeRule.text.trim() !== "") {
                                textElAg.innerHTML = activeRule.text;
                                textWrapperAg.style.display = 'block';
                            } else {
                                textWrapperAg.style.display = 'none';
                            }

                            var btnAgree = document.getElementById('qz-btn-agree');
                            var btnDisagree = document.getElementById('qz-btn-disagree');
                            
                            if (btnAgree) btnAgree.innerText = activeRule.btnAgree || "I Understand & Agree";
                            if (btnDisagree) {
                                btnDisagree.innerHTML = activeRule.btnDisagree || "I Decline";
                                btnDisagree.setAttribute('data-redirect', activeRule.redirectUrl || "https://levers.health");
                            }

                            var chkAgree = document.getElementById('qz-agree-check');
                            var chkDisagree = document.getElementById('qz-disagree-check');
                            if (chkAgree) chkAgree.parentElement.classList.remove('active-opt');
                            if (chkDisagree) chkDisagree.parentElement.classList.remove('active-opt');
                        }
                    }
                }

                if (currElement) currElement.classList.add('active-step');

                if (currElement) {
                    var dynamicInputs = currElement.querySelectorAll('.qz-dynamic-text');
                    dynamicInputs.forEach(function (input) {
                        var key = input.getAttribute('data-key');
                        if (key) {
                            input.value = self.userData.answers[key] || '';
                        }
                    });
                }

                if (currentStepId === 'step-contact') {
                    var contactTitle = document.querySelector('#step-contact .qz-title');
                    var identityChoice = this.userData.answers['contact_identity_choice'];
                    if (contactTitle) {
                        if (identityChoice === 'for-someone-else') {
                            contactTitle.innerHTML = 'Patient <span class="qz-gradient-text">Contact Information</span>';
                        } else {
                            contactTitle.innerHTML = 'Let\'s get <span class="qz-gradient-text">started.</span>';
                        }
                    }
                }

                if (currentStepId === 'step-marketing-details') {
                    var sourceVal = this.userData.answers['marketing_source'] || "Option";
                    var dynamicSpan = document.getElementById('qz-marketing-dynamic-val');

                    // Mensajes específicos según la fuente
                    var subMessages = {
                        'Referred by a friend or family': "If a friend or family member referred you, please let us know their name so that we can thank them!",
                        'Referred by another patient': "If another patient referred you, please let us know their name so that we can thank them!",
                        'Doctor or healthcare provider': "Please let us know the name of the doctor or healthcare provider who referred you.",
                        'Weight loss community group': "Please let us know which weight loss community group referred you.",
                        'Other': "Please let us know how you heard about us."
                    };

                    var subEl = document.querySelector('#step-marketing-details .qz-sub');
                    if (subEl && subMessages[sourceVal]) {
                        subEl.innerHTML = subMessages[sourceVal];
                    }

                    if (sourceVal.length > 30) sourceVal = "this option";
                    if (dynamicSpan) dynamicSpan.innerText = sourceVal;
                }

                // Usar DOM cacheado
                var header = this.DOM.header;
                var wrapper = this.DOM.wrapper;
                var bar = this.DOM.barFill;
                var isCompletionStep = ['step-thank-you', 'step-already-completed', 'step-all-set', 'step-order-refunded'].includes(currentStepId);

                if (bar) {
                    // Denominador fijo: estimación del flujo completo (~30 pasos).
                    // Esto evita que la barra "regrese" cuando calculateRoute descubre más pasos.
                    var TOTAL_ESTIMATED_STEPS = 30;
                    var pct = ((this.stepIndex + 1) / TOTAL_ESTIMATED_STEPS) * 100;
                    // Solo forzar 100% en los pasos finales reales
                    if (isCompletionStep) {
                        pct = 100;
                    }
                    bar.style.width = Math.min(pct, 100) + '%';
                }

                if ((currentStepId === 'step-thank-you' || currentStepId === 'step-already-completed') && !this.autoRedirectActive && !this.redirectTimeout) {
                    this.startAutoRedirect();
                }

                // Siempre aplicar el modo fullscreen ('focus-mode' y 'lock-body') a todos los pasos
                if (wrapper) {
                    wrapper.classList.add('qz-focus-mode');
                    wrapper.scrollTop = 0;
                }
                document.body.classList.add('qz-lock-body');

                if (this.stepIndex === 0 || isCompletionStep) {
                    if (header) header.style.setProperty('display', 'none', 'important');
                } else {
                    if (header) header.style.setProperty('display', 'block', 'important');

                    var bBtn = document.getElementById('qz-back-btn');
                    var pCon = document.querySelector('.qz-progress-container');
                    if (bBtn) bBtn.style.setProperty('display', 'flex', 'important');
                    if (pCon) pCon.style.setProperty('display', 'block', 'important');
                }
            },

            saveDynamicTextAndNext: function () {
                var textarea = document.getElementById('dynamic-other-textarea');
                var parentKey = textarea.getAttribute('data-parent');
                var textValue = textarea.value.trim();

                this.userData.answers[parentKey + '-details'] = textValue;

                return true;
            },

            handleBMIException: function (actionOrEl, actionParam) {
                var self = this;
                var action = actionParam || actionOrEl;
                
                // Si viene de un click en opción (no de runWithFeedback)
                if (actionOrEl && actionOrEl.classList && actionOrEl.classList.contains('qz-option')) {
                    var p = actionOrEl.parentElement;
                    p.querySelectorAll('.qz-option').forEach(function (o) { o.classList.remove('active-opt'); });
                    actionOrEl.classList.add('active-opt');
                }

                if (action === 'decline') {
                    self.showKnockout(
                        "Consultation Stopped",
                        "BMI Requirement",
                        "You have declined to proceed based on the BMI requirements. If you would like a refund, please use the button below.",
                        true,
                        "REFUND_REQUEST"
                    );
                } else if (action === 'exception') {
                    if (!self.userData.answers['agreements_accepted']) {
                        self.userData.answers['agreements_accepted'] = [];
                    }

                    self.userData.answers['agreements_accepted'].push({
                        category: "bmi_exception",
                        condition: "bmi_low_threshold",
                        agreement_title: "BMI Protocol Exception Request",
                        agreement_text: "User is requesting a protocol exception. Attestation: Already on GLP-1 therapy or has medical justification for current dose despite BMI metrics.",
                        attestation: "I Request Provider Exception",
                        timestamp: new Date().toISOString()
                    });

                    self.userData.answers['bmi_exception_requested'] = true;
                    self.next();
                }
            },

            handleMetricInput: function (id) {
                this.clearError(id);
                var input = document.getElementById(id);
                var val = parseFloat(input.value);
                if (val < 0) input.value = '';
                
                // Debounce el cálculo de BMI para no calcular en cada tecla
                this.debounce('bmi', function() {
                    this.updateLiveBMI();
                }, 200);
            },

            updateLiveBMI: function () {
                // Usar INPUTS cacheados
                var ft = this.INPUTS.ft ? this.INPUTS.ft.value : '';
                var inc = this.INPUTS.inches ? this.INPUTS.inches.value : '';
                var lbs = this.INPUTS.lbs ? this.INPUTS.lbs.value : '';

                var display = document.getElementById('qz-bmi-live-val');
                var circle = document.getElementById('qz-visual-circle');

                display.innerText = "--";
                circle.classList.remove('is-success');

                if (ft && lbs) {
                    var ftVal = parseFloat(ft);
                    var incVal = parseFloat(inc) || 0;
                    var lbsVal = parseFloat(lbs);
                    var totalInches = (ftVal * 12) + incVal;

                    if (totalInches > 0 && lbsVal > 0) {
                        var bmi = (lbsVal / (totalInches * totalInches)) * 703;
                        display.innerText = bmi.toFixed(1);

                        var threshold = this.BMI_RULES['DEFAULT'];
                        
                        // ✅ NUEVO: Usar el threshold más alto de las variantes GLP si existen
                        if (this.isGLP && this.glpVariants && this.glpVariants.length > 0) {
                            var maxThreshold = 0;
                            this.glpVariants.forEach(function(v) {
                                if (v.threshold > maxThreshold) maxThreshold = v.threshold;
                            });
                            if (maxThreshold > 0) threshold = maxThreshold;
                        } else {
                            // Fallback a lógica por variantName
                            var variantName = this.userData.orderContext.variantName || "";
                            if (variantName.includes('Microdose')) { threshold = this.BMI_RULES['Microdose']; }
                            else if (variantName.includes('Low-Dose') || variantName.includes('Low Dose')) {
                                threshold = this.BMI_RULES['Low-Dose'];
                            }
                        }

                        if (bmi >= threshold) {
                            circle.classList.add('is-success');
                        } else {
                            circle.classList.remove('is-success');
                        }
                    }
                }
            },

            handleDOBInput: function (el, maxLen, nextId) {
                this.clearError('qz-dob');
                var wrapper = document.getElementById('dob-wrapper');
                if (wrapper) wrapper.classList.remove('input-error');

                if (el.value.length > maxLen) el.value = el.value.slice(0, maxLen);

                if (el.value.length === maxLen && nextId) {
                    const nextEl = document.getElementById(nextId);
                    if (nextEl) nextEl.focus();
                }
                this.syncDOB();
            },

            syncDOB: function () {
                const y = document.getElementById('dob-year').value;
                const m = document.getElementById('dob-month').value.padStart(2, '0');
                const d = document.getElementById('dob-day').value.padStart(2, '0');
                if (y && m && d) {
                    document.getElementById('qz-dob').value = y + '-' + m + '-' + d;
                }
            },

            validateDOB: function () {
                const yInput = document.getElementById('dob-year');
                const mInput = document.getElementById('dob-month');
                const dInput = document.getElementById('dob-day');
                const wrapper = document.getElementById('dob-wrapper');

                const y = parseInt(yInput.value);
                const m = parseInt(mInput.value);
                const d = parseInt(dInput.value);

                if (!y || !m || !d) {
                    this.showError('qz-dob', 'Please complete your full date of birth.');
                    if (wrapper) wrapper.classList.add('input-error');
                    return false;
                }

                const dobFinal = y + '-' + String(m).padStart(2, '0') + '-' + String(d).padStart(2, '0');
                const age = this.calculateAge(dobFinal);

                if (age < 18) {
                    const title = "Age warning";
                    const subtitle = "Sorry, this service is only available for individuals aged 18 or older.";
                    const msg = "Please reach out to us if you have any questions; otherwise your purchase will be refunded within 48 hours";

                    this.showKnockout(title, subtitle, msg, true, "REFUND_REQUEST");
                    return false;
                }

                if (y < 1920 || y > new Date().getFullYear()) {
                    this.showError('qz-dob', 'Please enter a valid year.');
                    if (wrapper) wrapper.classList.add('input-error');
                    return false;
                }

                var date = new Date(y, m - 1, d);
                if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) {
                    this.showError('qz-dob', 'Please enter a valid date.');
                    if (wrapper) wrapper.classList.add('input-error');
                    return false;
                }

                this.syncDOB();
                this.userData.answers['dob'] = dobFinal;
                this.userData.answers['calculated_age'] = age;

                return true;
            },

            validateDynamicText: function (stepId) {
                var stepEl = document.getElementById(stepId);
                if (!stepEl) return true;

                var textInputs = stepEl.querySelectorAll('.qz-dynamic-text');
                var self = this;

                textInputs.forEach(function (input) {
                    var val = input.value.trim();
                    var key = input.getAttribute('data-key');
                    if (key) {
                        self.userData.answers[key] = self.sanitizeInput(val);
                    }
                });

                return true;
            },

            setSex: function (val) {
                this.userData.answers['sex'] = val;
                this.next();
            },

            handleFileSelect: function (input) {
                var self = this;
                var file = input.files[0];
                var errorId = 'qz-id-file';
                var initUI = document.getElementById('qz-upload-init-ui');
                var successUI = document.getElementById('qz-upload-success-ui');
                var dropzone = document.getElementById('qz-dropzone');
                var preview = document.getElementById('qz-id-preview');

                if (!file) return;

                // Validación: Solo imágenes permitidas (no PDFs ni documentos)
                var allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
                if (!allowedTypes.includes(file.type)) {
                    this.showError(errorId, 'Please upload an image file (JPG, PNG, or WebP). PDFs and documents are not allowed.');
                    input.value = "";
                    return;
                }

                // Validación: 10 MB máximo del archivo original
                if (file.size > 10 * 1024 * 1024) {
                    this.showError(errorId, 'File too large. Max 10MB.');
                    input.value = "";
                    return;
                }

                // COMPRIMIR y luego leer como base64
                this.compressImage(file, 1200, 0.8).then(function (compressed) {
                    var blobToRead = compressed.isCompressed ? compressed.blob : file;

                    var reader = new FileReader();
                    reader.onload = function (e) {
                        preview.src = e.target.result;

                        initUI.classList.add('qz-hidden');
                        successUI.classList.remove('qz-hidden');
                        dropzone.classList.add('has-file');
                        self.clearError(errorId);

                        // Guardar base64 del archivo COMPRIMIDO
                        self.userData.answers['id_photo_base64'] = e.target.result;
                    };
                    reader.onerror = function () {
                        /* Error leyendo archivo comprimido */
                        self.showError(errorId, 'Error processing image. Please try again.');
                    };
                    reader.readAsDataURL(blobToRead);

                }).catch(function (err) {
                    /* Error en compresión */
                    // Fallback: usar archivo original si la compresión falla
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        preview.src = e.target.result;
                        initUI.classList.add('qz-hidden');
                        successUI.classList.remove('qz-hidden');
                        dropzone.classList.add('has-file');
                        self.clearError(errorId);
                        self.userData.answers['id_photo_base64'] = e.target.result;
                    };
                    reader.readAsDataURL(file);
                });
            },

            validateIDUpload: function () {
                if (!this.userData.answers['id_photo_base64']) {
                    this.showError('qz-id-file', 'Please upload a photo of your ID to continue.');
                    return false;
                }
                return true;
            },

            selectSingle: function (el, key, val) {
                var p = el.parentElement;
                p.querySelectorAll('.qz-option').forEach(function (o) { o.classList.remove('active-opt'); });
                el.classList.add('active-opt');
                this.userData.answers[key] = val;
            },

            selectAndNext: function (el, key, val) {
                // ✅ Prevenir múltiples clics
                if (this._isNavigating) return;
                this._isNavigating = true;

                if (document.activeElement) document.activeElement.blur();

                var self = this;

                if (this.KNOCKOUT_RULES[key] && this.KNOCKOUT_RULES[key][val]) {
                    var rule = this.KNOCKOUT_RULES[key][val];
                    this.showOverlay(rule.title, rule.msg);
                    var p = el.parentElement;
                    p.querySelectorAll('.qz-option').forEach(function (o) { o.classList.remove('active-opt'); });
                    el.classList.add('active-opt');
                    this._isNavigating = false;
                    return;
                }

                var p = el.parentElement;
                p.querySelectorAll('.qz-option').forEach(function (o) { o.classList.remove('active-opt'); });
                el.classList.add('active-opt');

                this.userData.answers[key] = val;

                // Usar requestAnimationFrame para asegurar que el DOM se actualice antes de navegar
                requestAnimationFrame(function() {
                    setTimeout(function () { 
                        self._isNavigating = false;
                        self.next(); 
                    }, 350);
                });
            },

            toggleMulti: function (el, key, val, isExclusive) {
                if (document.activeElement) document.activeElement.blur();

                this.clearError('qz-' + key);

                if (!Array.isArray(this.userData.answers[key])) {
                    this.userData.answers[key] = [];
                }
                var currentArr = this.userData.answers[key];
                var parent = el.parentElement;

                if (isExclusive) {
                    if (el.classList.contains('active-opt')) {
                        el.classList.remove('active-opt');
                        this.userData.answers[key] = [];
                    } else {
                        parent.querySelectorAll('.qz-option').forEach(function (o) { o.classList.remove('active-opt'); });
                        el.classList.add('active-opt');
                        this.userData.answers[key] = [val];
                    }
                    return;
                }

                if (currentArr.includes('None') || currentArr.includes('None / No Diabetes') || currentArr.includes('None / No conditions')) {
                    this.userData.answers[key] = [];
                    currentArr = [];
                    var exclusiveOption = Array.from(parent.querySelectorAll('.qz-option')).find(function (opt) {
                        return opt.innerText.includes('None');
                    });
                    if (exclusiveOption) exclusiveOption.classList.remove('active-opt');
                }

                if (el.classList.contains('active-opt')) {
                    el.classList.remove('active-opt');
                    this.userData.answers[key] = currentArr.filter(function (item) { return item !== val; });
                } else {
                    el.classList.add('active-opt');
                    this.userData.answers[key].push(val);
                }
            },

            validateMulti: function (key) {
                var rawArr = this.userData.answers[key];

                var selectedArr = (rawArr || []).filter(function (e) { return e && e !== ''; });

                this.userData.answers[key] = selectedArr;

                var baseId = 'qz-' + key;

                if (selectedArr.length === 0) {
                    this.showError(baseId, 'Please select at least one option to continue.');

                    var errorDiv = document.getElementById(baseId + '-error');
                    if (errorDiv) errorDiv.scrollIntoView({ behavior: "smooth", block: "center" });

                    return false;
                }

                var rulesForKey = this.KNOCKOUT_RULES[key];
                if (rulesForKey) {
                    for (var i = 0; i < selectedArr.length; i++) {
                        var answer = selectedArr[i];
                        if (rulesForKey[answer]) {
                            var rule = rulesForKey[answer];
                            this.showOverlay(rule.title, rule.msg);
                            return false;
                        }
                    }
                }

                this.next();
            },

            validateFemale: function () {
                var preg = this.userData.answers['Pregnancy_And_Hormonal_Status'];
                var meno = this.userData.answers['Menopause_Stage'];

                if (!preg || !meno) {
                    this.showError('qz-female-error', 'Please answer both questions to continue.');
                    return;
                }

                var currentVariantId = String(this.userData.orderContext.variantId || "");
                var isExempt = currentVariantId !== "" && this.EXEMPT_VARIANT_IDS.includes(currentVariantId);

                if (!isExempt) {
                    if (this.KNOCKOUT_RULES['Pregnancy_And_Hormonal_Status'] && this.KNOCKOUT_RULES['Pregnancy_And_Hormonal_Status'][preg]) {
                        var rule = this.KNOCKOUT_RULES['Pregnancy_And_Hormonal_Status'][preg];
                        this.showOverlay(rule.title, rule.msg);
                        return false;
                    }
                    if (this.KNOCKOUT_RULES['Menopause_Stage'] && this.KNOCKOUT_RULES['Menopause_Stage'][meno]) {
                        var rule = this.KNOCKOUT_RULES['Menopause_Stage'][meno];
                        this.showOverlay(rule.title, rule.msg);
                        return false;
                    }
                }
                this.next();
            },

            calculateAge: function (dobString) {
                if (!dobString) return 0;

                const parts = dobString.split('-');
                const birthYear = parseInt(parts[0]);
                const birthMonth = parseInt(parts[1]) - 1;
                const birthDay = parseInt(parts[2]);

                const today = new Date();
                let age = today.getFullYear() - birthYear;
                const m = today.getMonth() - birthMonth;

                if (m < 0 || (m === 0 && today.getDate() < birthDay)) {
                    age--;
                }
                return age;
            },

            showKnockout: function (title, subtitle, message, showBackButton, exitUrl) {
                var overlay = document.getElementById('qz-knockout-overlay');
                var titleEl = document.getElementById('qz-knockout-title');
                var subEl = document.getElementById('qz-knockout-sub');
                var msgEl = document.getElementById('qz-knockout-message');
                var backBtn = document.getElementById('qz-knockout-back');
                var exitBtn = document.getElementById('qz-knockout-exit');

                // Configurar contenido
                if (titleEl) titleEl.innerHTML = title || "Not Eligible";

                // Subtítulo (nuevo elemento)
                if (subEl) {
                    if (subtitle && subtitle.trim() !== "") {
                        subEl.innerHTML = subtitle;
                        subEl.style.display = 'block';
                    } else {
                        subEl.innerHTML = "";
                        subEl.style.display = 'none';
                    }
                }

                if (msgEl) msgEl.innerHTML = message || "";

                // Configurar botón de retroceso
                if (backBtn) {
                    if (showBackButton) {
                        backBtn.style.display = 'block';
                        backBtn.onclick = function () {
                            this.closeKnockout();
                        }.bind(this);
                    } else {
                        backBtn.style.display = 'none';
                    }
                }

                // Configurar botón de salida (ahora dinámico para refund o exit)
                if (exitBtn) {
                    if (exitUrl === "REFUND_REQUEST") {
                        exitBtn.innerHTML = "<span>Request Refund</span>";
                        exitBtn.classList.add('qz-btn-agree-glow');
                        exitBtn.onclick = function () {
                            this.submitRefundRequest(title + " - " + (subtitle || "No subtitle"));
                        }.bind(this);
                    } else {
                        exitBtn.onclick = function () {
                            if (exitUrl) {
                                window.location.href = exitUrl;
                            } else {
                                window.location.href = "https://levers.health";
                            }
                        };
                    }
                }

                // Mostrar overlay
                if (overlay) {
                    overlay.classList.add('is-visible');
                    document.body.style.overflow = 'hidden'; // Bloquear scroll
                }

                // Efecto de shake en el paso actual si existe
                var currentStep = document.querySelector('.qz-step.active-step');
                if (currentStep) {
                    currentStep.classList.add('knockout-shake');
                    setTimeout(function () {
                        currentStep.classList.remove('knockout-shake');
                    }, 500);
                }
            },

            closeKnockout: function () {
                var overlay = document.getElementById('qz-knockout-overlay');
                if (overlay) {
                    overlay.classList.remove('is-visible');
                    document.body.style.overflow = '';
                }

                // Limpiar mensajes
                var subEl = document.getElementById('qz-knockout-sub');
                if (subEl) subEl.style.display = 'none';
                
                // Resetear botones del knockout
                var exitBtn = document.getElementById('qz-knockout-exit');
                var backBtn = document.getElementById('qz-knockout-back');
                if (exitBtn) {
                    exitBtn.disabled = false;
                    exitBtn.innerHTML = '<span>Exit Form & Request Refund</span>';
                }
                if (backBtn) backBtn.disabled = false;
            },

            handleAgreement: function (decision) {
                var parentStepId = this.currentRoute[this.stepIndex - 1];
                if (parentStepId === 'step-dynamic-other') {
                    parentStepId = this.currentRoute[this.stepIndex - 2];
                }
                var parentKey = parentStepId.replace('step-', '');

                if (parentKey === 'female') {
                    var pregAns = this.userData.answers['Pregnancy_And_Hormonal_Status'];
                    var menoAns = this.userData.answers['Menopause_Stage'];
                    var pregRules = this.AGREEMENT_RULES['Pregnancy_And_Hormonal_Status'];
                    var menoRules = this.AGREEMENT_RULES['Menopause_Stage'];
                    if (pregRules && pregRules[pregAns]) {
                        parentKey = 'Pregnancy_And_Hormonal_Status';
                    } else if (menoRules && menoRules[menoAns]) {
                        parentKey = 'Menopause_Stage';
                    }
                }

                if (decision === 'agree') {
                    var rules = this.AGREEMENT_RULES[parentKey];
                    var selectedAnswers = this.userData.answers[parentKey];
                    var activeRule = null;
                    var triggerValue = "";

                    if (rules) {
                        if (Array.isArray(selectedAnswers)) {
                            triggerValue = selectedAnswers.find(function (a) { return rules[a]; });
                            if (triggerValue) activeRule = rules[triggerValue];
                        } else {
                            triggerValue = selectedAnswers;
                            if (rules[triggerValue]) activeRule = rules[triggerValue];
                        }
                    }

                    if (activeRule) {
                        if (!this.userData.answers['agreements_accepted']) {
                            this.userData.answers['agreements_accepted'] = [];
                        }

                        this.userData.answers['agreements_accepted'].push({
                            category: parentKey,
                            condition: triggerValue,
                            agreement_title: activeRule.title,
                            agreement_text: (activeRule.sub + " " + (activeRule.text || "")).trim(),
                            attestation: activeRule.btnAgree || "I Understand & Agree",
                            timestamp: new Date().toISOString()
                        });
                    }

                    this.next();

                } else {
                    var rules = this.AGREEMENT_RULES[parentKey];
                    var selectedAnswers = this.userData.answers[parentKey];
                    var activeRule = null;
                    
                    if (rules) {
                        if (Array.isArray(selectedAnswers)) {
                             var triggerVal = selectedAnswers.find(function (a) { return rules[a]; });
                             if (triggerVal) activeRule = rules[triggerVal];
                        } else {
                             if (rules[selectedAnswers]) activeRule = rules[selectedAnswers];
                        }
                    }

                    if (activeRule && activeRule.knockout) {
                        this.showKnockout(
                            activeRule.knockout.title || "Consultation Stopped",
                            activeRule.knockout.sub || "Agreement Not Accepted",
                            activeRule.knockout.msg || "We cannot proceed with your intake without your consent to these medical terms.",
                            true,
                            "REFUND_REQUEST"
                        );
                    } else {
                        // Fallback por si no hay metadata de knockout
                        this.showKnockout(
                            "Consultation Stopped",
                            "Agreement Not Accepted",
                            "We cannot proceed with your intake without your consent to these medical terms. If you would like a refund, please contact support or use the refund request option.",
                            true,
                            "REFUND_REQUEST"
                        );
                    }
                }
            },

            showError: function (id, msg) {
                var input = document.getElementById(id);
                var errDiv = document.getElementById(id + '-error');
                if (input) input.classList.add('input-error');
                if (errDiv) {
                    errDiv.innerText = msg;
                    errDiv.classList.add('show-error');
                }
            },

            clearError: function (id) {
                var input = document.getElementById(id);
                var errDiv = document.getElementById(id + '-error');
                if (input) input.classList.remove('input-error');
                if (errDiv) {
                    errDiv.classList.remove('show-error');
                    errDiv.innerText = '';
                }
            },

            validateState: function () {
                var s = document.getElementById('qz-state-select').value;

                if (!CONFIG.ALLOWED_STATES.includes(s)) {
                    var knockoutTitle = "State not allowed";
                    var knockoutSub = "We're sorry, but this <strong>medical program does not service your state yet</strong>.<br><br>If you made this selection in error, you can go back and revise.<br><br>Otherwise, your purchase will be <strong>refunded within 48 hours</strong>. Please contact us with any questions or help needed. We're happy to assist."
                    var knockoutMsg = "We currently service the following states: AZ, CO, FL, GA, IL, MO, MS, NC, NV, NY, ND, OH, OK, OR, PA, SD, TN, TX, VA, WA, WY<br><br>If you would like to request a refund now, please use the button below.";
                    this.showKnockout(knockoutTitle, knockoutSub, knockoutMsg, true, "REFUND_REQUEST");
                    return false;
                }
                
                // Guardar estado seleccionado
                this.userData.answers['state'] = s;

                // Verificar restricciones de productos para este estado
                var restrictionStatus = this.checkProductStateRestrictions(s);

                if (restrictionStatus === 'all_restricted') {
                    var productNames = this.restrictedProducts.map(function (p) { return p.name; }).join(', ');
                    this.showKnockout(
                        "Products Not Available",
                        "Unfortunately, this protocol <strong>(" + productNames + ")</strong> is not available to ship to your state <strong>" + s + "</strong> (yet). If you made this selection in error, you can go back and revise.",
                        "Currently serving:<br><strong>AZ, CO, FL, GA, IL, MO, MS, NC, NV, NY, ND, OH, OK, OR, PA, SD, TN, TX, VA, WA, WY</strong>",
                        true,
                        "REFUND_REQUEST"
                    );
                    return false;
                }

                // Si hay algunas restricciones, guardar para que calculateRoute muestre el step
                if (restrictionStatus === 'some_restricted') {
                    this.saveToSession();
                }

                return true;
            },

            calcBMI: function () {
                this.clearError('qz-ft');
                this.clearError('qz-in');
                this.clearError('qz-lbs');

                // Usar INPUTS cacheados
                var ftInput = this.INPUTS.ft;
                var inInput = this.INPUTS.inches;
                var lbsInput = this.INPUTS.lbs;

                if (!ftInput || !ftInput.value || ftInput.value <= 0) {
                    this.showError('qz-ft', 'Required');
                    return false;
                }
                if (!inInput || inInput.value === "") {
                    this.showError('qz-in', 'Required');
                    return false;
                }
                if (!lbsInput || !lbsInput.value || lbsInput.value <= 0) {
                    this.showError('qz-lbs', 'Weight is required');
                    return false;
                }

                var ftVal = parseFloat(ftInput.value);
                var incVal = parseFloat(inInput.value) || 0;
                var lbsVal = parseFloat(lbsInput.value);

                if (isNaN(ftVal) || isNaN(incVal) || isNaN(lbsVal)) {
                    this.showError('qz-ft', 'Enter valid numbers');
                    return false;
                }

                var totalInches = (ftVal * 12) + incVal;
                var bmiValue = parseFloat(((lbsVal / (totalInches * totalInches)) * 703).toFixed(1));

                // Guardar métricas
                this.userData.answers['bmi_metrics'] = {
                    ft: ftVal,
                    in: incVal,
                    lbs: lbsVal,
                    bmi: bmiValue
                };

                // ✅ NUEVO: Evaluar contra todas las variantes GLP
                if (this.isGLP && this.glpVariants.length > 0) {
                    this.evaluateGLPVariantsBMI(bmiValue);
                } else {
                    // Fallback a lógica antigua si no hay variantes
                    this.userData.bmiStatus = (bmiValue >= 25) ? 'eligible' : 'warning';
                }

                this.next();
            },

            // ==========================================
            // CONTACT VERIFICATION UTILITIES & HANDLERS
            // ==========================================

            normalizePhone: function (phone) {
                // Strip all non-digits, then remove leading country code "1" if 11 digits
                var digits = (phone || "").replace(/\D/g, "");
                if (digits.length === 11 && digits.charAt(0) === '1') {
                    digits = digits.substring(1);
                }
                return digits;
            },

            normalizeEmail: function (email) {
                return (email || "").toLowerCase().trim();
            },

            formatPhoneDisplay: function (phone) {
                // Format any phone to +1 (xxx) xxx-xxxx
                var digits = this.normalizePhone(phone);
                if (digits.length === 10) {
                    return '+1 (' + digits.substring(0, 3) + ') ' + digits.substring(3, 6) + '-' + digits.substring(6);
                }
                return phone || '';
            },

            checkContactMismatch: function () {
                if (!this._originalCustomer) {
                    this._contactMismatch = null;
                    return;
                }

                var newEmail = this.normalizeEmail(this.userData.customer.email);
                var newPhone = this.normalizePhone(this.userData.customer.phone);
                var origEmail = this._originalCustomer.email;
                var origPhone = this._originalCustomer.phone;

                var emailChanged = newEmail !== origEmail;
                var phoneChanged = newPhone !== origPhone;

                if (emailChanged && phoneChanged) {
                    this._contactMismatch = { type: 'both', emailChanged: true, phoneChanged: true };
                } else if (emailChanged) {
                    this._contactMismatch = { type: 'email', emailChanged: true, phoneChanged: false };
                } else if (phoneChanged) {
                    this._contactMismatch = { type: 'phone', emailChanged: false, phoneChanged: true };
                } else {
                    this._contactMismatch = null;
                }

                // Clear previous identity choice and metadata when mismatch state changes
                if (this._contactMismatch) {
                    delete this.userData.answers['contact_identity_choice'];
                    delete this.userData.answers['contactUpdate'];
                    delete this.userData.answers['formSomeoneElse'];
                    delete this.userData.answers['agreements_accepted'];
                }
            },

            handleSingleVerification: function () {
                this.userData.answers['contactUpdate'] = 'Update My Information';
                this.userData.answers['formSomeoneElse'] = false;
                this.next();
            },

            handleIdentityChoice: function (el, val) {
                if (document.activeElement) document.activeElement.blur();

                var p = el.parentElement;
                p.querySelectorAll('.qz-option').forEach(function (o) { o.classList.remove('active-opt'); });
                el.classList.add('active-opt');

                this.userData.answers['contact_identity_choice'] = val;

                // Clear error if previously shown
                var errEl = document.getElementById('qz-identity-error');
                if (errEl) { errEl.classList.remove('show-error'); errEl.innerText = ''; }
            },

            confirmIdentityChoice: function () {
                var choice = this.userData.answers['contact_identity_choice'];
                if (!choice) {
                    var errEl = document.getElementById('qz-identity-error');
                    if (errEl) {
                        errEl.innerText = 'Please select an option to continue.';
                        errEl.classList.add('show-error');
                    }
                    return false; // Indica error para no continuar
                }

                this.userData.answers['formSomeoneElse'] = (choice === 'for-someone-else');
                this.next();
            },

            handleConfirmUpdate: function () {
                this.userData.answers['contactUpdate'] = 'I Understand & Continue';
                this.userData.answers['formSomeoneElse'] = false;
                this.next();
            },

            handleContactProxyAgreement: function (decision) {
                if (decision === 'agree') {
                    this.userData.answers['contactUpdate'] = 'I Understand & Agree';
                    this.userData.answers['formSomeoneElse'] = true;

                    if (!this.userData.answers['agreements_accepted']) {
                        this.userData.answers['agreements_accepted'] = [];
                    }

                    this.userData.answers['agreements_accepted'].push({
                        category: 'contact_proxy',
                        condition: 'filling_for_someone_else',
                        agreement_title: 'Third-Party Medical Information Consent',
                        agreement_text: 'This medical intake form should be filled out by the person receiving treatment. If you continue, you agree that all the information provided is accurate and that you have permission to submit medical information on behalf of this person.',
                        attestation: 'I Understand & Agree',
                        timestamp: new Date().toISOString()
                    });

                    this.next();
                } else {
                    this.showKnockout(
                        "Consultation Stopped",
                        "Proxy Consent Required",
                        "To fill this form on behalf of someone else, their consent and your authorization are required. Since this wasn't confirmed, we'll need to process a refund.",
                        true,
                        "REFUND_REQUEST"
                    );
                }
            }
        };

        // Ejecución robusta
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", function () {
                window.QZ.init();
            });
        } else {
            window.QZ.init();
        }

    })();